import Header from "./header/header";
import Footer from "./footer/footer";
import NavBar from "./nav/nav-bar";
import { useHistory, useParams } from "react-router";
import "./call-insight.css";
import WebPull from "./webservice/web-pull";
import Service from "./webservice/http";
import { useEffect, useState } from "react";
//import Wavesurfer from "react-wavesurfer.js";
//import Timeline from "react-wavesurfer.js";
import { Link } from "react-router-dom";
import "./footer/footer.css";

import { WaveSurfer, WaveForm, Region } from "wavesurfer-react";
import RegionsPlugin from "wavesurfer.js/dist/plugin/wavesurfer.regions.min";
import TimelinePlugin from "wavesurfer.js/dist/plugin/wavesurfer.timeline.min";
import React, { useCallback, useRef, useMemo } from "react";
import NavbarCollapse from "react-bootstrap/esm/NavbarCollapse";
import ReactDOM from "react-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { BiError, BiCommentAdd, BiTaskX } from "react-icons/bi";
import { RiSignalWifiErrorFill, RiDeleteRow } from "react-icons/ri";
import { FcCustomerSupport } from "react-icons/fc";
import { MdPendingActions } from "react-icons/md";
import { BsCheckLg } from "react-icons/bs";
import { FaTimes } from "react-icons/fa";
import Modal from "react-modal";
import { FiEdit } from "react-icons/fi";
import { BiArchiveIn } from "react-icons/bi";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import Highlighter from "react-highlight-words";
import Dropdown from "rsuite/Dropdown";

import { storage } from "./utils/storage";

import "rsuite/dist/rsuite.min.css";
import { Items } from "./Items";
import Masonry from "react-masonry-css";
import arrowDown from "./assets/images/arrow-down-black.svg";
import info from "./assets/images/info.svg";

const simpleDiff = (oldStr, newStr) => {
  if (!oldStr) return [{ value: newStr, added: true }];
  if (!newStr) return [{ value: oldStr, removed: true }];

  const oldParts = oldStr.split(/(\b)/).filter((p) => p.length > 0);
  const newParts = newStr.split(/(\b)/).filter((p) => p.length > 0);

  let oldIdx = 0;
  let newIdx = 0;
  const result = [];

  while (oldIdx < oldParts.length || newIdx < newParts.length) {
    if (
      oldIdx < oldParts.length &&
      newIdx < newParts.length &&
      oldParts[oldIdx] === newParts[newIdx]
    ) {
      result.push({ value: oldParts[oldIdx], equal: true });
      oldIdx++;
      newIdx++;
    } else {
      let bestMatch = null;
      const limit = 20;

      for (let i = 0; i < limit && oldIdx + i < oldParts.length; i++) {
        for (let j = 0; j < limit && newIdx + j < newParts.length; j++) {
          if (i === 0 && j === 0) continue;
          if (oldParts[oldIdx + i] === newParts[newIdx + j]) {
            const val = oldParts[oldIdx + i];

            const isWord = /[a-zA-Z0-9]{2,}/.test(val);
            const score = isWord ? 10 : 1;
            const distance = i + j;
            const finalScore = score * 10 - distance;

            if (!bestMatch || finalScore > bestMatch.score) {
              bestMatch = { i, j, score: finalScore };
            }
          }
        }
      }

      if (bestMatch && bestMatch.score > 0) {
        const removed = oldParts.slice(oldIdx, oldIdx + bestMatch.i).join("");
        const added = newParts.slice(newIdx, newIdx + bestMatch.j).join("");

        if (removed) result.push({ value: removed, removed: true });
        if (added) result.push({ value: added, added: true });

        oldIdx += bestMatch.i;
        newIdx += bestMatch.j;
      } else {
        const removed = oldParts.slice(oldIdx).join("");
        const added = newParts.slice(newIdx).join("");

        if (removed) result.push({ value: removed, removed: true });
        if (added) result.push({ value: added, added: true });
        break;
      }
    }
  }

  const consolidated = [];
  result.forEach((part) => {
    const last = consolidated[consolidated.length - 1];
    if (
      last &&
      ((last.removed && part.removed) ||
        (last.added && part.added) ||
        (last.equal && part.equal))
    ) {
      last.value += part.value;
    } else {
      consolidated.push(part);
    }
  });

  return consolidated;
};

const CallInsight = () => {
  const { callID } = useParams();
  const history = useHistory();

  //const { data: callInsight, error, isPending } = WebPull(`https://fb.dataklout.com/api/call/${callID}/call_insight/`)
  const [callInsight, setCallInsight] = useState(null);
  const [error, setError] = useState("");
  const [isPending, setIsPending] = useState(false);
  const services = new Service();
  const [expand, setExpand] = useState(false);
  const [isLanguageEnglish, setIsLanguageEnglish] = useState(true);
  const [displayEnglish, setDisplayEnglish] = useState(true);

  const [editableTranscriptions, setEditableTranscriptions] = useState([]);
  const [originalTranscriptions, setOriginalTranscriptions] = useState([]);
  const [isEditingAll, setIsEditingAll] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [showPromptsModal, setShowPromptsModal] = useState(false);

  const editableRefs = useRef([]);

  var english = true;
  var ci = null;
  const [activeKey, setActiveKey] = useState("Product");
  /**
   * Fetch Call Insight data
   */
  // console.log(callInsight);

  const [showedit, setshowedit] = useState(true);

  const clientName = storage.getItem("client_name");
  const useCase = storage.getItem("usecase");
  const [reportid, setReportid] = useState("");
  const [activeTab, setActiveTab] = useState("Dataklout");
  // console.log(usecase);

  const handleSubmit = (e) => {
    e.preventDefault();
    services
      .patch(`api/call/${callID}/call_insight/`, updatedCallInsight)
      .then((res) => {
        // console.log("checkkkkkkk", res);
        // window.location.reload();
      });
    // console.log("HFDYTJHFYJHF", updatedCallInsight);
    setshowedit(true);
  };

  const handleInputChange = (event) => {
    // console.log("handleInputChange called");
    const { name, value } = event.target;
    // console.log("name:", name);
    // console.log("value:", value);

    setupdatedCallInsight((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const [updatedCallInsight, setupdatedCallInsight] = useState({});

  function fetchData() {
    setError("");
    setIsPending(true);
    setCallInsight(null);
    services.get(`api/call/${callID}/call_insight/`).then((res) => {
      // console.log("checking", res);
      setIsPending(false);
      if (res == "TypeError: Failed to fetch") {
        setError("Connection Error");
      } else {
        if (res.code == "token_not_valid") {
          storage.clear();
          history.push("/login");
        }
        setCallInsight(res);
        setupdatedCallInsight({
          name: res.name,
          request_type: res.request_type,
          product: res.product,
          buy: res.buy,
          sell: res.sell,

          amount: res.amount,
          company_name: res.company_name,

          price: res.price,
          shares: res.shares,

          final_price: res.final_price,
          units: res.units,
          date: res.date,
          folio_number: res.folio_number,

          contract_number: res.contract_number,
          quantity: res.quantity,
        });
        setReportid(res.report_id);
        // console.log("reportid", res.report_id);
        // console.log(res, "checking");
        if (res.language !== "English") {
          setIsLanguageEnglish(false);
          setDisplayEnglish(false);
          english = false;
        }

        ci = res;
        setError("");
        try {
          wavesurferRef.current.load(res.audio_file);
        } catch {}
      }
    });
  }
  const [reviewerEnglish, setReviewerEnglish] = useState(false);
  const [reviewTranscription, setReviewTranscription] = useState();
  const [isReviewTranscriptionPending, setIsReviewTranscriptionPending] =
    useState(false);

  function fetchreviewdata() {
    setIsReviewTranscriptionPending(true);
    services
      .get(`api/call/${callID}/edit_transcription/`)
      .then((res) => {
        if (res?.code === "token_not_valid") {
          storage.clear();
          history.push("/login");
          return;
        }
        setReviewTranscription(res);
        // console.log("hyhyhyhy", res);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsReviewTranscriptionPending(false);
      });
  }

  const VERSION_COLORS = {
    1: { bg: "hsla(180, 95%, 75%, 0.9)", text: "hsla(180, 70%, 25%, 1)" }, // Cyan
    2: { bg: "hsla(320, 90%, 80%, 0.9)", text: "hsla(320, 70%, 25%, 1)" }, // Magenta
    3: { bg: "hsla(30, 100%, 75%, 0.9)", text: "hsla(30, 70%, 25%, 1)" }, // Orange
    4: { bg: "hsla(90, 85%, 70%, 0.9)", text: "hsla(90, 60%, 25%, 1)" }, // Lime
    5: { bg: "hsla(350, 95%, 80%, 0.9)", text: "hsla(350, 70%, 30%, 1)" }, // Rose
    6: { bg: "hsla(45, 100%, 70%, 0.9)", text: "hsla(45, 70%, 25%, 1)" }, // Gold
    7: { bg: "hsla(260, 90%, 80%, 0.9)", text: "hsla(260, 70%, 25%, 1)" }, // Violet
    8: { bg: "hsla(160, 85%, 75%, 0.9)", text: "hsla(160, 70%, 25%, 1)" }, // Mint
    9: { bg: "hsla(15, 95%, 75%, 0.9)", text: "hsla(15, 70%, 25%, 1)" }, // Coral
    10: { bg: "hsla(280, 85%, 82%, 0.9)", text: "hsla(280, 70%, 25%, 1)" }, // Lavender
  };

  const getVersionColor = (version) => {
    if (version <= 10) {
      return VERSION_COLORS[version] || VERSION_COLORS[1];
    }

    const hue = (version * 137.5) % 360;
    return {
      bg: `hsla(${hue}, 85%, 75%, 0.9)`,
      text: `hsla(${hue}, 70%, 25%, 1)`,
    };
  };

  useEffect(() => {
    fetchData();
    fetchreviewdata();
  }, []);
  /**
   * Fetch Call Insight data
   */

  // console.log(updatedCallInsight);

  const [agentVariance, setAgentVariance] = useState(null);
  const [customerVariance, setCustomerVariance] = useState(null);
  const [agentLoudness, setAgentLoudness] = useState(null);
  const [customerLoudness, setCustomerLoudness] = useState(null);
  const [agentEntropy, setAgentEntropy] = useState(null);
  const [customerEntropy, setCustomerEntropy] = useState(null);
  const [agentEnergy, setAgentEnergy] = useState(null);
  const [customerEnergy, setCustomerEnergy] = useState(null);

  const [criticalFactor, setCriticalFactor] = useState(null);

  function fetchCriticalFactorData() {
    services.get(`api/call/${callID}/critical_factor/`).then((res) => {
      // console.log(res);
      setIsPending(false);
      if (res == "TypeError: Failed to fetch") {
        setError("Connection Error");
      } else {
        if (res.code == "token_not_valid") {
          storage.clear();
          history.push("/login");
        }
        setCriticalFactor(res);
        setProblem(res.problem);
        setResolution(res.resolution);
      }
    });
  }

  const [problem, setProblem] = useState("");
  const [resolution, setResolution] = useState("");
  function criticalValueSelectionChnage(type, id) {
    var tempCriticalFactor = criticalFactor;
    if (type === "product") {
      var products = tempCriticalFactor.product;
      for (let i = 0; i < products.length; i++) {
        if (products[i].id === id) {
          products[i].status = true;
        } else {
          products[i].status = false;
        }
      }
      tempCriticalFactor.product = products;
    }

    if (type === "manufacturer") {
      var manufacturer = tempCriticalFactor.manufacturer;
      for (let i = 0; i < manufacturer.length; i++) {
        if (manufacturer[i].id === id) {
          manufacturer[i].status = true;
        } else {
          manufacturer[i].status = false;
        }
      }
      tempCriticalFactor.manufacturer = manufacturer;
    }

    if (type === "part_no") {
      var part_no = tempCriticalFactor.part_no;
      for (let i = 0; i < part_no.length; i++) {
        if (part_no[i].id === id) {
          part_no[i].status = true;
        } else {
          part_no[i].status = false;
        }
      }
      tempCriticalFactor.part_no = part_no;
    }

    if (type === "model_no_list") {
      var model_no_list = tempCriticalFactor.model_no_list;
      for (let i = 0; i < model_no_list.length; i++) {
        if (model_no_list[i].id === id) {
          model_no_list[i].status = true;
        } else {
          model_no_list[i].status = false;
        }
      }
      tempCriticalFactor.model_no_list = model_no_list;
    }

    setCriticalFactor(tempCriticalFactor);
    // console.log(criticalFactor);
  }

  const updateCriticalFactor = () => {
    var selected_product = "";
    var selected_manufacturer = "";
    var selected_part_no = "";
    var selected_model = "";

    for (let i = 0; i < criticalFactor.product.length; i++) {
      if (criticalFactor.product[i].status === true) {
        selected_product = criticalFactor.product[i].id;
      }
    }
    for (let i = 0; i < criticalFactor.manufacturer.length; i++) {
      if (criticalFactor.manufacturer[i].status === true) {
        selected_manufacturer = criticalFactor.manufacturer[i].id;
      }
    }
    for (let i = 0; i < criticalFactor.part_no.length; i++) {
      if (criticalFactor.part_no[i].status === true) {
        selected_part_no = criticalFactor.part_no[i].id;
      }
    }
    for (let i = 0; i < criticalFactor.model_no_list.length; i++) {
      if (criticalFactor.model_no_list[i].status === true) {
        selected_model = criticalFactor.model_no_list[i].id;
      }
    }
    var data = {
      problem: problem,
      resolution: resolution,
      product: selected_product,
      manufacturer: selected_manufacturer,
      partNo: selected_part_no,
      modelNo: selected_model,
    };

    services.post(`api/call/${callID}/critical_factor/`, data).then((res) => {
      // console.log(res);
      if (res == "TypeError: Failed to fetch") {
        setError("Connection Error");
      } else {
        if (res.code == "token_not_valid") {
          storage.clear();
          history.push("/login");
        }
        NotificationManager.success("Success", "Critical Factor updated");
      }
    });
  };

  // useEffect(() => {
  //     console.log(criticalFactor);
  // }, [criticalFactor]);

  useEffect(() => {
    fetchData();
    //buildFilter();
    if (storage.getItem("critical_factor_module") === "true") {
      fetchCriticalFactorData();
    }

    // console.log(callInsight);
    fetchSupportingInfo();
  }, [history]);

  /**
   * After fetching call insight data, process that data to display in required format
   */

  useEffect(() => {
    var i = 0;
    for (i = 0; i < 2; i++) {
      try {
        if (callInsight.pitch_variance[i].Speaker === "agent") {
          setAgentVariance(callInsight.pitch_variance[i].pitchvar);
        }
        if (callInsight.pitch_variance[i].Speaker === "customer") {
          setCustomerVariance(callInsight.pitch_variance[i].pitchvar);
        }
        if (callInsight.loudness[i].speaker === "agent") {
          setAgentLoudness(callInsight.loudness[i].loudness);
        }
        if (callInsight.loudness[i].speaker === "customer") {
          setCustomerLoudness(callInsight.loudness[i].loudness);
        }
        if (callInsight.entropy[i].speaker === "agent") {
          setAgentEntropy(callInsight.entropy[i].entropy);
        }
        if (callInsight.entropy[i].speaker === "customer") {
          setCustomerEntropy(callInsight.entropy[i].entropy);
        }
        if (callInsight.energy[i].speaker === "agent") {
          setAgentEnergy(callInsight.energy[i].energy);
        }
        if (callInsight.energy[i].speaker === "customer") {
          setCustomerEnergy(callInsight.energy[i].energy);
        }
        if (callInsight.call_type === "Collection") {
          fetchCollectionStatusData();
        }
      } catch {}
    }
  }, [callInsight]);

  // new parameters
  const expandedParameters = [
    {
      key: "tone_result",
      parametername: "Tonality",
      agent: callInsight?.tone_result?.[0]?.tone_result || 0,
      customer: callInsight?.tone_result?.[1]?.tone_result || 0,
      viewForAgent: true,
    },
    {
      key: "speaking_rate",
      parametername: "Words/minute",
      agent: callInsight?.speaking_rate?.[0]?.speaking_rate || 0,
      customer: callInsight?.speaking_rate?.[1]?.speaking_rate || 0,
      viewForAgent: true,
    },
    {
      key: "articulation_rate",
      parametername: "Articulation Rate",
      agent: callInsight?.articulation_rate?.[0]?.articulation_rate || 0,
      customer: callInsight?.articulation_rate?.[1]?.articulation_rate || 0,
      viewForAgent: true,
    },
    {
      key: "syllable_rate",
      parametername: "Syllable Rate",
      agent: callInsight?.syllable_rate?.[0]?.syllable_rate || 0,
      customer: callInsight?.syllable_rate?.[1]?.syllable_rate || 0,
      viewForAgent: false,
    },
    {
      key: "emotional_intensity",
      parametername: "Emotional Intensity",
      agent: callInsight?.emotional_intensity?.[0]?.emotional_intensity || 0,
      customer: callInsight?.emotional_intensity?.[1]?.emotional_intensity || 0,
      viewForAgent: true,
    },
    {
      key: "pronunciation_accuracy",
      parametername: "Pronunciation Accuracy",
      agent:
        callInsight?.pronounciation_accuracy?.[0]?.pronounciation_accuracy || 0,
      customer:
        callInsight?.pronounciation_accuracy?.[1]?.pronounciation_accuracy || 0,
      viewForAgent: true,
    },
    {
      key: "tremor",
      parametername: "Tremor",
      agent: callInsight?.tremor?.[0]?.tremor || 0,
      customer: callInsight?.tremor?.[1]?.tremor || 0,
      viewForAgent: false,
    },
    {
      key: "jitter",
      parametername: "Jitter",
      agent: callInsight?.jitter?.[0]?.jitter || 0,
      customer: callInsight?.jitter?.[1]?.jitter || 0,
      viewForAgent: false,
    },
    {
      key: "shimmer",
      parametername: "Shimmer",
      agent: callInsight?.shimmer?.[0]?.shimmer || 0,
      customer: callInsight?.shimmer?.[1]?.shimmer || 0,
      viewForAgent: false,
    },
    {
      key: "tone",
      parametername: "Tone",
      agent: callInsight?.tone?.[0]?.tone || 0,
      customer: callInsight?.tone?.[1]?.tone || 0,
      viewForAgent: true,
    },
    {
      key: "resonance",
      parametername: "Resonance",
      agent: callInsight?.resonance?.[0]?.resonance || 0,
      customer: callInsight?.resonance?.[1]?.resonance || 0,
      viewForAgent: false,
    },

    {
      key: "semantic_similarity",
      parametername: "Semantic Similarity",
      agent: callInsight?.semantic_similarity?.[0]?.semantic_similarity || 0,
      customer: callInsight?.semantic_similarity?.[1]?.semantic_similarity || 0,
      viewForAgent: false,
    },

    {
      key: "emotional_valence",
      parametername: "Emotional Valence",
      agent: callInsight?.emotional_valence?.[0]?.emotional_valence || 0,
      customer: callInsight?.emotional_valence?.[1]?.emotional_valence || 0,
      viewForAgent: true,
    },
    {
      key: "irony_detection",
      parametername: "Irony Detection",
      agent: callInsight?.irony_detection?.[0]?.irony_detection || 0,
      customer: callInsight?.irony_detection?.[1]?.irony_detection || 0,
      viewForAgent: false,
    },
    {
      key: "language_biases",
      parametername: "Language Biases",
      agent: callInsight?.language_biases?.[0]?.language_biases || 0,
      customer: callInsight?.language_biases?.[1]?.language_biases || 0,
      viewForAgent: true,
    },
    {
      key: "spectral_density",
      parametername: "Spectral Density",
      agent: callInsight?.spectral_density?.[0]?.spectral_density || 0,
      customer: callInsight?.spectral_density?.[1]?.spectral_density || 0,
      viewForAgent: false,
    },
    {
      key: "spectral_flux",
      parametername: "Spectral Flux",
      agent: callInsight?.spectral_flux?.[0]?.spectral_flux || 0,
      customer: callInsight?.spectral_flux?.[1]?.spectral_flux || 0,
      viewForAgent: false,
    },
    {
      key: "spectral_rolloff",
      parametername: "Spectral Rolloff",
      agent: callInsight?.spectral_rolloff?.[0]?.spectral_rolloff || 0,
      customer: callInsight?.spectral_rolloff?.[1]?.spectral_rolloff || 0,
      viewForAgent: false,
    },
    {
      key: "spectral_tilt",
      parametername: "Spectral Tilt",
      agent: callInsight?.spectral_tilt?.[0]?.spectral_tilt || 0,
      customer: callInsight?.spectral_tilt?.[1]?.spectral_tilt || 0,
      viewForAgent: false,
    },
    {
      key: "spectral_centroid",
      parametername: "Spectral Centroid",
      agent: callInsight?.spectral_centroid?.[0]?.spectral_centroid || 0,
      customer: callInsight?.spectral_centroid?.[1]?.spectral_centroid || 0,
      viewForAgent: false,
    },
    {
      key: "spectral_flatness",
      parametername: "Spectral Flatness",
      agent: callInsight?.spectral_flatness?.[0]?.spectral_flatness || 0,
      customer: callInsight?.spectral_flatness?.[1]?.spectral_flatness || 0,
      viewForAgent: false,
    },
    {
      key: "formant_frequencies",
      parametername: "Formant Frequencies",
      agent: callInsight?.formant_frequencies?.[0]?.formant_frequencies || 0,
      customer: callInsight?.formant_frequencies?.[1]?.formant_frequencies || 0,
      viewForAgent: false,
    },
    {
      key: "spectral_kurtosis",
      parametername: "Spectral Kurtosis",
      agent: callInsight?.spectral_kurtosis?.[0]?.spectral_kurtosis || 0,
      customer: callInsight?.spectral_kurtosis?.[1]?.spectral_kurtosis || 0,
      viewForAgent: false,
    },
    {
      key: "spectral_skewness",
      parametername: "Spectral Skewness",
      agent: callInsight?.spectral_skewness?.[0]?.spectral_skewness || 0,
      customer: callInsight?.spectral_skewness?.[1]?.spectral_skewness || 0,
      viewForAgent: false,
    },
  ];

  const expandedParametersCollection = [
    {
      key: "background_noise_level",
      parametername: "Sharpness of Sound",
      agent:
        callInsight?.background_noise_level?.[0]?.background_noise_level || 0,
      customer:
        callInsight?.background_noise_level?.[1]?.background_noise_level || 0,
      viewForAgent: false,
    },
    {
      key: "recording_clarity",
      parametername: "Sharpness Variation",
      agent: callInsight?.recording_clarity?.[0]?.recording_clarity || 0,
      customer: callInsight?.recording_clarity?.[1]?.recording_clarity || 0,
      viewForAgent: false,
    },
    {
      key: "average_sound_energy",
      parametername: "Sound Movement",
      agent: callInsight?.average_sound_energy?.[0]?.average_sound_energy || 0,
      customer:
        callInsight?.average_sound_energy?.[1]?.average_sound_energy || 0,
      viewForAgent: false,
    },
    {
      key: "energy_variation",
      parametername: "Sound Movement Variation",
      agent: callInsight?.energy_variation?.[0]?.energy_variation || 0,
      customer: callInsight?.energy_variation?.[1]?.energy_variation || 0,
      viewForAgent: false,
    },
    {
      key: "overall_variability",
      parametername: "Overall Sound Variation",
      agent: callInsight?.energy_variation?.[0]?.energy_variation || 0,
      customer: callInsight?.energy_variation?.[1]?.energy_variation || 0,
      viewForAgent: false,
    },
  ];

  // console.log(callInsight);
  const [collectionStatusData, setCollectionStatusData] = useState(null);

  /**
   * Fetch current status of collection if it is a collection call
   */
  function fetchCollectionStatusData() {
    services.get(`api/call/${callID}/collection_status/`).then((res) => {
      // console.log(res);
      if (res == "TypeError: Failed to fetch") {
        setError("Connection Error");
      } else {
        setCollectionStatusData(res);
        setCollectionStatus(res.updated_status);
      }
    });
  }

  const [showCollectionReviewDetails, setShowCollectionReviewDetails] =
    useState(false);
  useEffect(() => {
    fetchCollectionStatusData();
  }, [showCollectionReviewDetails]);
  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  const [collectionStatus, setCollectionStatus] = useState("");
  const [comment, setComment] = useState("");
  const [accepted, setAccepted] = useState(false);

  /**
   * Update current status of collection
   */
  function updateCollectionStatusData() {
    if (callInsight.agent_id === storage.getItem("username")) {
      var data = {
        type: "agent",
        updated_status: collectionStatus,
      };
    }
    if (callInsight.agent_id !== storage.getItem("username")) {
      var data = {
        type: "manager",
        status_id: collectionStatusData.id,
        accepted: accepted,
        comment: comment,
      };
    }
    services.post(`api/call/${callID}/collection_status/`, data).then((res) => {
      // console.log(res);
      if (res == "TypeError: Failed to fetch") {
        setError("Connection Error");
      } else {
        if (res.code == "token_not_valid") {
          storage.clear();
          history.push("/login");
        }
        setShowCollectionReviewDetails(false);
      }
    });
  }

  // console.log(updatedCallInsight);
  useEffect(() => {
    buildFilter();
  }, [callInsight]);

  // const [match, setMatch] = useState("");

  // async function callInsightMatch() {
  //   let url = `api/call/${callID}/pcvc_insight/`;
  //   const res = await services.get(url).then((res) => {
  //     setMatch(res);
  //     // console.log(res,"ffff")
  //   });
  // }
  // useEffect(() => {
  //   callInsightMatch();
  // }, []);

  const [emotions, setEmotions] = useState(null);
  const [speakers, setSpeakers] = useState(null);

  /**
   * filter speech region based on selected speaker and selected emotiom
   * It is required to display filter range
   * @param {*} filter_type Filter Type
   * @param {*} filter Filter
   */
  function regionFilterFun(filter_type, filter) {
    var regionData = [];
    if (callInsight != null) {
      var i = 1;
      callInsight.speech.map((speechItem) => {
        if (filter_type == "speaker") {
          if (filter == "agent") {
            if (speechItem.speaker == "agent") {
              regionData.push({
                id: "region-" + i.toString(),
                start: speechItem.startTime,
                end: speechItem.endTime,
                color: "rgba(255, 196, 226, 0.4)",
                data: {
                  systemRegionId: i,
                },
              });
            }
          } else {
            if (speechItem.speaker == "customer") {
              regionData.push({
                id: "region-" + i.toString(),
                start: speechItem.startTime,
                end: speechItem.endTime,
                color: "rgba(255, 255, 0, 0.4)",
                data: {
                  systemRegionId: i,
                },
              });
            }
          }
        } else {
          if (filter == "Happy") {
            if (speechItem.emotion == "Happy") {
              regionData.push({
                id: "region-" + i.toString(),
                start: speechItem.startTime,
                end: speechItem.endTime,
                color: "rgba(0,228,255,0.2)",
                data: {
                  systemRegionId: i,
                },
              });
            }
          } else if (filter == "Fearful") {
            if (speechItem.emotion == "Fearful") {
              regionData.push({
                id: "region-" + i.toString(),
                start: speechItem.startTime,
                end: speechItem.endTime,
                color: "rgba(0,64,255,0.2)",
                data: {
                  systemRegionId: i,
                },
              });
            }
          } else if (filter == "Angry") {
            if (speechItem.emotion == "Angry") {
              regionData.push({
                id: "region-" + i.toString(),
                start: speechItem.startTime,
                end: speechItem.endTime,
                color: "rgba(58,255,0,0.2)",
                data: {
                  systemRegionId: i,
                },
              });
            }
          } else if (filter == "Sad") {
            if (speechItem.emotion == "Sad") {
              regionData.push({
                id: "region-" + i.toString(),
                start: speechItem.startTime,
                end: speechItem.endTime,
                color: "rgba(255,0,255,0.2)",
                data: {
                  systemRegionId: i,
                },
              });
            }
          } else {
            if (speechItem.emotion == "Calm") {
              regionData.push({
                id: "region-" + i.toString(),
                start: speechItem.startTime,
                end: speechItem.endTime,
                color: "rgba(255,0,0,0.2)",
                data: {
                  systemRegionId: i,
                },
              });
            }
          }
        }
        i++;
      });

      setRegions(regionData);
    }
  }

  function buildFilter() {
    var emotions = [];
    var speakers = [];
    if (callInsight != null) {
      callInsight.speech.map((speechItem) => {
        if (emotions.indexOf(speechItem.emotion) === -1) {
          emotions.push(speechItem.emotion);
        }
        if (speakers.indexOf(speechItem.speaker) === -1) {
          speakers.push(speechItem.speaker);
        }
      });
    }
    setEmotions(emotions);
    setSpeakers(speakers);
  }

  const play = useCallback(() => {
    wavesurferRef.current.playPause();
  }, []);

  const [regions, setRegions] = useState([]);
  const [isPlaying, setIsPlaying] = useState(false);

  const [timelineVis, setTimelineVis] = useState(true);
  const wavesurferRef = useRef();
  const regionsRef = useRef(regions);
  const plugins = useMemo(() => {
    return [
      {
        plugin: RegionsPlugin,
        options: { dragSelection: true },
      },
      timelineVis && {
        plugin: TimelinePlugin,
        options: {
          container: "#timeline",
          color: "#000000",
          fontSize: "25px",
        },
      },
    ].filter(Boolean);
  }, [timelineVis]);

  /**
   * Create region on audio web graph
   */
  const regionCreatedHandler = useCallback(
    (region) => {
      // console.log("region-created --> region:", region);

      if (region.data.systemRegionId) return;

      setRegions([
        ...regionsRef.current,
        { ...region, data: { ...region.data, systemRegionId: -1 } },
      ]);
    },
    [regionsRef],
  );

  /**
   * Load audio packets and create webgraph
   */
  const handleWSMount = useCallback(
    (waveSurfer) => {
      wavesurferRef.current = waveSurfer;
      if (wavesurferRef.current) {
        wavesurferRef.current.params.waveColor = "#2196f3";
        wavesurferRef.current.params.progressColor = "#000000";
        wavesurferRef.current.params.backgroundColor = "#0000";
        wavesurferRef.current.params.responsive = true;
        wavesurferRef.current.params.fillParent = true;
        wavesurferRef.current.params.scrollParent = true;
        wavesurferRef.current.setHeight(210);

        wavesurferRef.current.on("region-created", regionCreatedHandler);

        wavesurferRef.current.on("ready", () => {
          // console.log("WaveSurfer is ready");
        });

        wavesurferRef.current.on("region-removed", (region) => {
          // console.log("region-removed --> ", region);
        });

        wavesurferRef.current.on("loading", (data) => {
          // console.log("loading --> ", data);
        });

        wavesurferRef.current.on("play", () => {
          setIsPlaying(true);
        });

        wavesurferRef.current.on("pause", () => {
          try {
            ReactDOM.render("", document.getElementById("transcriptionDiv"));
            setIsPlaying(false);
          } catch {}
        });

        wavesurferRef.current.on("audioprocess", () => {
          var t = waveSurfer.getCurrentTime();
          setPlayTime(t);
        });

        wavesurferRef.current.on("finish", () => {
          ReactDOM.render("", document.getElementById("transcriptionDiv"));
          setIsPlaying(false);
        });

        if (window) {
          window.surferidze = wavesurferRef.current;
        }
      }
    },
    [regionCreatedHandler],
  );

  /**
   * Manage region update in webgraph
   */
  const handleRegionUpdate = useCallback((region, smth) => {
    // console.log("region-update-end --> region:", region);
    // console.log(smth);
  }, []);

  const [playTime, setPlayTime] = useState(null);

  /**
   * Handle transcription display while playing the audio and on change of language togglge
   */
  useEffect(() => {
    // console.log(playTime);
    try {
      // console.log(displayEnglish);
      var speech = callInsight.speech;
      for (let i = 0; i < speech.length; i++) {
        if (playTime >= speech[i].startTime && playTime <= speech[i].endTime) {
          var dialogue = "";
          if (displayEnglish) dialogue = speech[i].dialogue;
          else dialogue = speech[i].early_dialogue;
          if (speech[i].speaker === "agent") {
            ReactDOM.render(
              <div className="transcription-customer-section clearfix">
                <h4>{speech[i].speaker_name}</h4>
                <div className="customer-info-right">
                  <span>{formatTime(speech[i].startTime)}</span>
                  <p>
                    <Highlighter
                      highlightClassName="YourHighlightClass"
                      searchWords={[callInsight.product]}
                      autoEscape={true}
                      textToHighlight={dialogue}
                    />
                  </p>
                  <span>{formatTime(speech[i].endTime)}</span>
                </div>
              </div>,
              document.getElementById("transcriptionDiv"),
            );
          } else {
            ReactDOM.render(
              <div className="transcription-customer-section clearfix">
                <h4>{speech[i].speaker_name}</h4>
                <div className="customer-info-right">
                  <span>{formatTime(speech[i].startTime)}</span>
                  <p>
                    <Highlighter
                      highlightClassName="YourHighlightClass"
                      searchWords={[callInsight.product]}
                      autoEscape={true}
                      textToHighlight={dialogue}
                    />
                  </p>
                  <span>{formatTime(speech[i].endTime)}</span>
                </div>
              </div>,
              document.getElementById("transcriptionDiv"),
            );
          }
          break;
        }
      }
    } catch (e) {
      // console.log(e);
    }
  }, [playTime, displayEnglish]);

  useEffect(() => {
    return () => {
      try {
        wavesurferRef.current.pause();
      } catch {}
    };
  }, []);

  const [dbsCategory, setDbsCategory] = useState("");

  const fetchDbsCategory = async () => {
    try {
      const res = await services.get("api/product/trade_info/");

      // console.log(res, "dbs category");
      setDbsCategory(res);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchDbsCategory();
  }, []);

  const [showArchiveModel, setShowArchiveModel] = useState(false);
  function markArchive() {
    var data = {
      archive_status: true,
    };
    services.post(`api/call/${callID}/mark_archive/`, data).then((res) => {
      // console.log(res);
      if (res == "TypeError: Failed to fetch") {
        // console.log("failed to fetch user");
      } else {
        NotificationManager.success("Success", "Task Closed");
        setShowArchiveModel(false);
      }
    });
  }

  const [showOpportunitySRModel, setShowOpportunitySRModel] = useState(false);
  const [clickType, setClickType] = useState(null);

  function clickOpportunitySRModel(type) {
    setClickType(type);
    setShowOpportunitySRModel(true);
  }

  /**
   * Fetch product list from new call supporting info API
   */
  const [supportingInfo, setSupportingInfo] = useState();
  function fetchSupportingInfo() {
    services.get("api/call/new_call/").then((res) => {
      // console.log(res);
      if (res == "TypeError: Failed to fetch") {
      } else {
        if (res.code == "token_not_valid") {
          storage.clear();
          history.push("/login");
        }
        setSupportingInfo(res);
      }
    });
  }

  // console.log("dahfsdvljsakgdfvaskj", english);

  const [productID, setProductID] = useState(null);
  const [keyword, setkeyword] = useState(null);
  const [status, setStatus] = useState(null);

  function CreateOpportunitySR() {
    if (productID === null || keyword === null || status === "") {
      NotificationManager.error("Error", "All the fields are mandatory");
    } else {
      var data = {
        product_id: productID,
        keyword: keyword,
        review_status: status,
      };
      if (clickType === "Opportunity") {
        services
          .post(`api/call/${callID}/create_opportunity/`, data)
          .then((res) => {
            // console.log(res);
            if (res == "TypeError: Failed to fetch") {
              // console.log("failed to fetch user");
            } else {
              NotificationManager.success("Success", "Opportunity Creatred");
              setShowOpportunitySRModel(false);
              setProductID(null);
              setkeyword(null);
              setStatus(null);
            }
          });
      } else {
        services
          .post(`api/call/${callID}/create_service_request/`, data)
          .then((res) => {
            // console.log(res);
            if (res == "TypeError: Failed to fetch") {
              // console.log("failed to fetch user");
            } else {
              NotificationManager.success(
                "Success",
                "Service Requested Creatred",
              );
              setShowOpportunitySRModel(false);
              setProductID(null);
              setkeyword(null);
              setStatus(null);
            }
          });
      }
    }
  }

  const [category, setCategory] = useState("");

  // async function callCategory() {
  //   let url = `api/call/${callID}/pcvc_insight/`;

  //   const res = await services
  //     .get(url)

  //     .then((res) => {
  //       setCategory(res);
  //     });
  // }

  // useEffect(() => {
  //   callCategory();
  // }, []);

  const [edithistory, setEdithistory] = useState("");
  const [lineVersionMap, setLineVersionMap] = useState({});

  useEffect(() => {
    if (!callInsight?.speech) {
      setEditableTranscriptions([]);
      setOriginalTranscriptions([]);
      setIsEditingAll(false);
      setHasChanges(false);
      editableRefs.current = [];
      return;
    }

    const mapped =
      (reviewTranscription?.speech ?? []).map((t) => ({
        ...t,
        text: !reviewerEnglish ? t.early_dialogue : t.dialogue,
      })) ?? [];

    const safeClone = (() => {
      if (typeof structuredClone === "function") {
        return structuredClone(mapped);
      }
      return mapped === undefined ? [] : JSON.parse(JSON.stringify(mapped));
    })();

    setEditableTranscriptions(mapped);
    setOriginalTranscriptions(safeClone);

    setEdithistory(
      !reviewerEnglish
        ? reviewTranscription?.edit_summary?.edited_early_sz_transcription
        : reviewTranscription?.edit_summary?.edited_serialized_transcription,
    );

    const historyData = !reviewerEnglish
      ? reviewTranscription?.edit_history?.edited_early_sz_transcription
      : reviewTranscription?.edit_history?.edited_serialized_transcription;

    const newLineMap = {};

    if (historyData && Array.isArray(historyData)) {
      historyData.forEach((entry) => {
        if (entry.changed_indices && Array.isArray(entry.changed_indices)) {
          entry.changed_indices.forEach((idx) => {
            if (!newLineMap[idx] || entry.version_number > newLineMap[idx]) {
              newLineMap[idx] = entry.version_number;
            }
          });
        }
      });
    }
    setLineVersionMap(newLineMap);

    setIsEditingAll(false);
    setHasChanges(false);
    editableRefs.current = [];
  }, [callInsight, reviewerEnglish, reviewTranscription]);

  const renderDiff = (index, currentItem) => {
    const originalItem = callInsight?.speech?.[index];
    if (!originalItem)
      return (
        currentItem.text ||
        currentItem.early_dialogue ||
        currentItem.dialogue ||
        ""
      );

    const useDialogue = reviewerEnglish || callInsight?.language === "English";
    const originalText = useDialogue
      ? originalItem.dialogue
      : originalItem.early_dialogue;
    const currentText = useDialogue
      ? currentItem.text || currentItem.dialogue || ""
      : currentItem.text || currentItem.early_dialogue || "";

    if (originalText === currentText || isEditingAll) return currentText;

    const diff = simpleDiff(originalText || "", currentText || "");

    const versionNum =
      lineVersionMap[index] ?? (edithistory?.version_number || 1);
    const colors = getVersionColor(versionNum);

    return diff.map((part, i) => {
      if (part.added) {
        return (
          <span
            key={i}
            style={{
              backgroundColor: colors.bg,
              color: colors.text,
              padding: "0 2px",
              borderRadius: "2px",
            }}
          >
            {part.value}
          </span>
        );
      }
      if (part.removed) {
        return (
          <span
            key={i}
            style={{
              textDecoration: "line-through",
              color: "#991b1b",
              backgroundColor: "#fee2e2",
              padding: "0 2px",
              borderRadius: "2px",
            }}
          >
            {part.value}
          </span>
        );
      }
      return part.value;
    });
  };

  const placeCaretAtEnd = (el) => {
    if (!el) return;
    try {
      const range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (!isEditingAll) return;

    requestAnimationFrame(() => {
      editableRefs.current.forEach((el, index) => {
        if (!el) return;
        const txt =
          editableTranscriptions?.[index]?.text ??
          editableTranscriptions?.[index]?.early_dialogue ??
          "";
        if (el.innerText !== txt) {
          el.innerText = txt;
        }
      });
    });
  }, [isEditingAll, editableTranscriptions]);
  const handleLineChange = (index, newText) => {
    setEditableTranscriptions((prev) => {
      const copy = [...prev];
      if (!copy[index]) return prev;
      copy[index] = { ...copy[index], text: newText };
      return copy;
    });
    setHasChanges(true);
  };
  // console.log("haschnaged", hasChanges);

  const handleCancelAll = () => {
    setEditableTranscriptions(
      JSON.parse(JSON.stringify(originalTranscriptions)),
    );
    setIsEditingAll(false);
    setHasChanges(false);
  };

  const handleSaveAll = () => {
    if (!hasChanges) return;

    const updatesPayload = (editableTranscriptions || []).map((t, index) => ({
      index,
      dialogue: t.text,
    }));

    const data1 = {
      updates_early_sz: updatesPayload,
    };
    const data2 = {
      updates_serialized: updatesPayload,
    };

    services
      .post(
        `api/call/${callID}/edit_transcription/`,
        reviewerEnglish || callInsight?.language === "language" ? data2 : data1,
      )
      .then((res) => {
        if (res == "TypeError: Failed to fetch") {
        } else {
          setOriginalTranscriptions(
            JSON.parse(JSON.stringify(editableTranscriptions)),
          );
          setIsEditingAll(false);
          setHasChanges(false);
          NotificationManager.success("Success", "Transcription updated");
          fetchreviewdata();
          setEdithistory(
            !reviewerEnglish
              ? reviewTranscription?.edit_summary?.edited_early_sz_transcription
              : reviewTranscription?.edit_summary
                  ?.edited_serialized_transcription,
          );
        }
      });
  };

  // console.log(reviewerEnglish, "hyhy");

  const [showHistory, setShowHistory] = useState(false);

  // Notes state
  const [notesInput, setNotesInput] = useState("");
  const [notesData, setNotesData] = useState({ notes: [] });
  const [showAddNoteModal, setShowAddNoteModal] = useState(false);
  const [noteToDelete, setNoteToDelete] = useState(null);

  const fetchNotes = () => {
    services
      .get(`api/call/call-notes/?call_id=${callID}`)
      .then((res) => {
        setNotesData(
          Array.isArray(res) ? { notes: res } : res || { notes: [] },
        );
      })
      .catch((err) => {
        console.error("Failed to fetch notes:", err);
      });
  };

  // console.log(notesData);
  const handleAddNote = () => {
    const trimmed = notesInput.trim();
    if (!trimmed) return;
    const payload = { call_id: callID, text: trimmed };
    services
      .post("api/call/call-notes/", payload)
      .then((res) => {
        setNotesInput("");
        setShowAddNoteModal(false);
        fetchNotes();
      })
      .catch((err) => {
        console.error("Failed to add note:", err);
      });
  };

  const confirmDeleteNote = () => {
    services
      .request("api/call/call-notes/", "DELETE", {
        id: noteToDelete,
      })
      .then(() => {
        setNoteToDelete(null);
        fetchNotes();
      })
      .catch((err) => {
        console.error("Failed to delete note:", err);
        setNoteToDelete(null);
      });
  };

  useEffect(() => {
    if (callID) fetchNotes();
  }, [callID]);

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") setShowHistory(false);
    }
    if (showHistory) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [showHistory]);

  function formatTime(sec) {
    if (typeof sec !== "number" || Number.isNaN(sec)) return "-";
    const m = Math.floor(sec / 60)
      .toString()
      .padStart(2, "0");
    const s = Math.floor(sec % 60)
      .toString()
      .padStart(2, "0");
    return `${m}:${s}`;
  }

  const getPromptSpeaker = (p) => {
    const sp = p.speaker || p.track || p.speaker_name || "Agent";
    return sp.charAt(0).toUpperCase() + sp.slice(1).toLowerCase();
  };

  const getPromptTime = (p) => {
    const start =
      p.dialogue_start !== undefined ? p.dialogue_start : p.startTime;
    if (typeof start === "number") {
      return formatTime(start);
    }
    if (typeof start === "string" && start) {
      return start;
    }
    if (p.time) return p.time;
    if (p.timestamp) return p.timestamp;
    return "00:00";
  };

  const getPromptText = (p) => {
    return p.prompt || p.text || p.dialogue || p.message || "";
  };

  const getSpeakerStyles = (speaker) => {
    const capitalized = speaker.toUpperCase();
    if (capitalized === "CUSTOMER" || capitalized === "CLIENT") {
      return {
        background: "#fce7f3",
        color: "#9d174d",
      };
    }
    return {
      background: "#dbeafe",
      color: "#1e40af",
    };
  };

  useEffect(() => {
    if (showHistory) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [showHistory]);

  // console.log(callInsight?.ai_summary.summary);

  const [reviewerSummary, setReviewerSummary] = useState("");
  const [isEditingReviewer, setIsEditingReviewer] = useState(false);
  const reviewerRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [isImporting, setIsImporting] = useState(false);
  const importFileRef = React.useRef(null);

  async function handleImportExcel(file) {
    if (!file) return;
    setIsImporting(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      await services.postForm(
        `api/call/${callID}/import_collection_amount/`,
        formData,
      );
      NotificationManager.success("Success", "File imported successfully");
    } catch (err) {
      NotificationManager.error("Error", "Failed to import file");
    } finally {
      setIsImporting(false);
      setImportFile(null);
    }
  }

  const originalReviewerRef = useRef(reviewerSummary);

  function handleCancelEdit() {
    setReviewerSummary(originalReviewerRef.current || "");
    setIsEditingReviewer(false);
    if (typeof setHasChanges === "function") setHasChanges(false);

    const el = reviewerRef.current;
    if (el) el.blur();
  }

  useEffect(() => {
    if (callInsight?.ai_summary?.summary) {
      setReviewerSummary(callInsight.edit_summary.summary);
    }
  }, [callInsight]);

  async function saveReviewerSummary(text) {
    const payload = { summary: text };
    setIsSaving(true);
    try {
      const res = await services.post(
        `api/call/${callID}/edit_summary/`,
        payload,
      );
      NotificationManager.success("Success", "Call summary updated");
      const data = await res.json().catch(() => null);
      const savedText = data?.reviewer_summary || text;

      setReviewerSummary(savedText);

      originalReviewerRef.current = savedText;
      setIsEditingReviewer(false);
      if (typeof setHasChanges === "function") setHasChanges(false);

      return savedText;
    } catch (err) {
      console.error("Error saving reviewer summary:", err);

      throw err;
    } finally {
      setIsEditingReviewer(false);
      setIsSaving(false);
    }
  }

  function placeCaretAtEndSummary(el) {
    if (!el) return;
    el.focus();
    if (
      typeof window.getSelection !== "undefined" &&
      typeof document.createRange !== "undefined"
    ) {
      const range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(false);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }

  function handleReviewerClick(e) {
    e.stopPropagation();
    if (typeof setHasChanges === "function") setHasChanges(true);
    if (!isEditingReviewer) {
      originalReviewerRef.current = reviewerSummary;
      setIsEditingReviewer(true);
      requestAnimationFrame(() => {
        const el = reviewerRef.current;
        if (el) placeCaretAtEnd(el);
      });
    }
  }

  function handleReviewerBlur(e) {
    const newText = e.currentTarget.innerText || "";
    setReviewerSummary(newText);
  }

  function handleReviewerKeyDown(e) {
    if (e.key === "Enter") {
      e.preventDefault();
      e.currentTarget.blur();
    }
  }

  const [values, setValues] = useState({});

  const [tempValue, setTempValue] = useState("");
  const containerRef = useRef(null);
  const inputRef = useRef(null);
  const [editingKey, setEditingKey] = useState(null);

  useEffect(() => {
    setValues({
      collections:
        callInsight?.edit_collection_params?.collection_score_card ??
        "No Change",
      debtor: callInsight?.edit_collection_params?.debtor_status ?? "No Change",
      payment:
        callInsight?.edit_collection_params?.payment_pct === "Positive"
          ? "Positive"
          : callInsight?.edit_collection_params?.payment_pct === "Negative"
            ? "Negative"
            : "No Change",
    });
  }, [callInsight]);

  const startEdit = (key) => {
    setTempValue(values[key] ?? "");
    setEditingKey(key);

    setTimeout(() => inputRef.current?.focus?.(), 0);
  };

  const handleCancel = () => {
    setTempValue("");
    setEditingKey(null);
  };

  useEffect(() => {
    function handleDocClick(e) {
      if (!editingKey) return;
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        handleCancel();
      }
    }

    function handleDocKey(e) {
      if (!editingKey) return;
      if (e.key === "Escape") handleCancel();
      else if (e.key === "Enter") handleSave();
    }

    document.addEventListener("mousedown", handleDocClick);
    document.addEventListener("keydown", handleDocKey);
    return () => {
      document.removeEventListener("mousedown", handleDocClick);
      document.removeEventListener("keydown", handleDocKey);
    };
  }, [editingKey, tempValue, values]);

  useEffect(() => {
    if (editingKey && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select?.();
    }
  }, [editingKey]);

  const handleSave = () => {
    if (!editingKey) return;

    const updated = { ...values, [editingKey]: tempValue };
    console.log(updated);
    setValues(updated);
    setEditingKey(null);
    setTempValue("");

    const parsePercent = (v) => {
      const cleaned = String(v).replace("%", "").trim();
      const n = Number(cleaned);
      return Number.isFinite(n) ? n : null;
    };

    const parsePayment = (v) => {
      return String(v).toLowerCase().startsWith("pos");
    };

    const payload = {
      edit_collection_params: {
        collection_score_card: parsePercent(updated.collections),
        debtor_status: updated.debtor,
        payment_pct: updated.payment,
      },
    };

    const res = services
      .post(`api/call/${callID}/edit_collection_params/`, payload)
      .then((res) => {
        if (res == "TypeError: Failed to fetch") {
        } else {
          NotificationManager.success("Success", "Parameters updated");
        }
      });

    console.log("Updated entire object:", payload);
  };

  return (
    <div className="dashboard-body">
      <Header />
      <NavBar />
      <NotificationContainer />
      <section className="custom-wrapper-glife">
        <div
          className="container-fluid"
          style={{
            height:
              useCase === "Insurance - PCVC Verification" ? "1385px" : "auto",
          }}
        >
          <div className="my-call">
            {isPending && (
              <div className="empty-call" style={{ height: "500px" }}>
                <ClipLoader color="#2056FF" size="50px" />
              </div>
            )}

            {error && (
              <div className="empty-call" style={{ height: "500px" }}>
                <p style={{ fontSize: "25px", color: "#FF8520" }}>
                  {error === "Connection Error" && <RiSignalWifiErrorFill />}
                  {error !== "Connection Error" && <BiError />}
                  {error}
                </p>
              </div>
            )}

            {callInsight && (
              <div>
                <div className="my-calls-column">
                  <div className="calls-top-pannel">
                    <div className="row">
                      <div className="col-lg-12 ">
                        <div className="pannel-heading clearfix div-padding">
                          <div className="pannel-heading-icon">
                            <i className="flaticon-incoming-call"></i>
                          </div>
                          <div className="pannel-heading-info">
                            {useCase === "Third Party Collection Agency" ||
                            useCase === "Banking Collections PCVC" ? (
                              <p>Debt Insight </p>
                            ) : (
                              <p>Call Insight </p>
                            )}
                            <h3 className="detail-heading">
                              Customer Name & ID :{" "}
                              <span className="detail-heading-span">
                                {callInsight.customer}
                              </span>
                              {useCase == "Insurance - PCVC Verification" ? (
                                <span>
                                  <span>(NEMP Id :{"-"})</span>
                                </span>
                              ) : (
                                <span>
                                  <span>
                                    (Ref# :{callInsight.call_reference})
                                  </span>
                                </span>
                              )}
                              {/* <span>
                                <span>
                                  (Ref# :{callInsight.call_reference})
                                </span>
                              </span> */}
                              {/* <img src="/assets/images/blur-circle-check.png" /> */}
                            </h3>
                            <h3 className="detail-heading">
                              Agent Name :{" "}
                              <span className="detail-heading-span">
                                {callInsight.agent || "-"}
                              </span>
                            </h3>
                          </div>
                          <div className="pull-right flex items-center mt-2">
                            {useCase.includes("Collections") &&
                              storage.getItem("username") === "MYABCQT01" && (
                                <button
                                  className={`mr-4 btn text-white hover:text-white hover:shadow-lg`}
                                  style={{
                                    // border: "1px solid gray",
                                    backgroundColor: "#5BC0DE",
                                  }}
                                  onClick={() =>
                                    history.push(
                                      `/detailed-reports/${callInsight?.predue_id}`,
                                    )
                                  }
                                >
                                  Quality Audit
                                </button>
                              )}
                            {useCase.includes("Collections") &&
                              !storage.getItem("role").includes("Agent") &&
                              !storage.getItem("role").includes("Agenth") &&
                              !storage
                                .getItem("role")
                                .includes("Agent Collections") &&
                              !storage.getItem("role").includes("DCA Agent") &&
                              (storage.getItem("username") === "MYABCMR01" ||
                                storage.getItem("username") === "MYABCQT01" ||
                                storage.getItem("username") ===
                                  "GNLMNDVD01") && (
                                <button
                                  className="mr-4 btn text-white hover:text-white hover:shadow-lg"
                                  style={{ backgroundColor: "#5BC0DE" }}
                                  onClick={() =>
                                    history.push(
                                      `/call/${callID}/transcription-audit`,
                                    )
                                  }
                                >
                                  Transcription Audit
                                </button>
                              )}
                            {useCase.includes("Collections") &&
                              callInsight?.collection_strategy_access && (
                                <button
                                  className={`mr-4 btn text-white hover:text-white hover:shadow-lg ${
                                    callInsight?.collection_strategy_access
                                      ? ""
                                      : "disabled opacity-50 cursor-not-allowed"
                                  }`}
                                  style={{
                                    // border: "1px solid gray",
                                    backgroundColor: "#5BC0DE",
                                  }}
                                  onClick={() =>
                                    history.push(
                                      `/reports/detail/${callInsight?.predue_id}/collection-strategy`,
                                    )
                                  }
                                >
                                  Collection Strategy Audit
                                </button>
                              )}
                            <button
                              onClick={() => setShowArchiveModel(true)}
                              className="p-2 text-gray-700 hover:text-gray-900 focus:outline-none"
                            >
                              <BiArchiveIn size={40} />
                            </button>
                            &nbsp;&nbsp;
                            {callInsight.call_type === "Opportunity" &&
                              useCase !== "Insurance - PCVC Verification" &&
                              !useCase.includes("Collections") && (
                                <button
                                  className="btn btn-info pull-right"
                                  onClick={() =>
                                    clickOpportunitySRModel("Opportunity")
                                  }
                                >
                                  New Opportunity
                                </button>
                              )}
                            {callInsight.call_type === "Service Request" && (
                              <button
                                className="btn btn-info pull-right"
                                onClick={() =>
                                  clickOpportunitySRModel("Service Request")
                                }
                              >
                                New Service Request
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Masonry
                  breakpointCols={2}
                  className="my-masonry-grid_call-insight gap-3"
                  columnClassName="my-masonry-grid_column_call-insight"
                >
                  <div className="white-box-global ww-caps">
                    <div className="white-box-header">
                      <div className="pull-right flex gap-2">
                        <Link to={`/call/${callID}/deep-analysis`}>
                          <button className="btn btn-info">
                            Deep Analysis
                          </button>
                        </Link>
                        {!storage
                          .getItem("role")
                          ?.toLowerCase()
                          .includes("agent") &&
                          (storage.getItem("username") === "MYABCMR01" ||
                            storage.getItem("username") === "MYABCQT01" ||
                            storage.getItem("username") === "GNLMNDVD01" ||
                            storage.getItem("username") === "CLAUDIT01") && (
                            <button
                              className="btn btn-info"
                              onClick={() =>
                                history.push(
                                  `/call/${callID}/call-transcription-audit`,
                                )
                              }
                            >
                              Review Transcription
                            </button>
                          )}
                      </div>
                      {useCase === "Third Party Collection Agency" ||
                      useCase === "Banking Collections PCVC" ? (
                        <h3>Debtor Insight </h3>
                      ) : (
                        <h3>Call Insight </h3>
                      )}
                      {/* <h3>Call Insights</h3> */}
                    </div>
                    {/* top box */}
                    <div className="insights-body clearfix">
                      {useCase == "Insurance - PCVC Verification" ? (
                        <div className="flex flex-wrap gap-2">
                          <div className="flex-1">
                            <div className="insights-box">
                              <div className="insights-box-header clearfix">
                                <h4>Script</h4>
                                <img
                                  src="assets/images/cx-icon.png"
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <div className="insights-box-count">
                                <h2>- </h2>
                              </div>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="insights-box">
                              <div className="insights-box-header clearfix">
                                <h4>Fatal</h4>
                                <img
                                  src="assets/images/customer-icon.png"
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <div className="insights-box-count">
                                <h2>-</h2>
                              </div>
                            </div>
                          </div>

                          <div className="flex-1">
                            <div className="insights-box">
                              <div
                                className="insights-box-header clearfix"
                                style={{ whiteSpace: "nowrap" }}
                              >
                                <h4>Non Fatal</h4>
                                <img
                                  src="assets/images/agreeability-icon.png"
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <div className="insights-box-count">
                                <h2>-</h2>
                              </div>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="insights-box">
                              <div className="insights-box-header clearfix">
                                <h4>Verification</h4>
                                <img
                                  src="assets/images/resolution-icon.png"
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <div className="insights-box-count">
                                <h2>-</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : useCase == "Third Party Collection Agency" ||
                        useCase === "Banking Collections PCVC" ||
                        useCase.includes("Collections") ? (
                        <div
                          className="flex flex-wrap gap-2 my-6"
                          ref={containerRef}
                        >
                          <div className="flex flex-col px-4 text-2xl font-bold gap-3">
                            <div
                              className="px-4 py-8 "
                              style={{ backgroundColor: "#EEF2F5" }}
                            >
                              Source
                            </div>
                            <div
                              className=" flex flex-col px-4 text-2xl font-bold py-3 gap-7 mt-1"
                              style={{
                                // marginTop: "71px",
                                backgroundColor: "#EEF2F5",
                                height: "81px",
                              }}
                            >
                              <span>Dataklout</span>
                              <span>Reviewer</span>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div
                              className="insights-box"
                              style={{ height: "60px" }}
                            >
                              <div className="insights-box-header clearfix whitespace-nowrap font-medium">
                                <h4 style={{ fontSize: "18px" }}>
                                  Collections Score
                                </h4>
                                <img
                                  src="assets/images/cx-icon.png"
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <div
                                className="insights-box-count flex gap-7 flex-col px-4 py-4"
                                style={{
                                  backgroundColor: "#EEF2F5",
                                  marginTop: "20px",
                                  // borderRadius: "8px",
                                  height: "80px",
                                }}
                              >
                                <h2 style={{ fontSize: "18px" }}>
                                  {/* {Math.trunc(
                                    callInsight?.collection_params
                                      ?.collection_score_card,
                                  )} */}
                                  {callInsight?.call_collection_score || "-"}
                                </h2>
                                <span className=" flex justify-between items-center">
                                  {editingKey !== "collections" ? (
                                    <>
                                      <h2 style={{ fontSize: "14px" }}>
                                        {callInsight?.edit_collection_params
                                          ?.collection_score_card
                                          ? `${values?.collections}`
                                          : values?.collections}
                                      </h2>

                                      <span
                                        className="cursor-pointer"
                                        onClick={() => {
                                          setTempValue(
                                            String(values.collections),
                                          );
                                          startEdit("collections");
                                        }}
                                      >
                                        <i
                                          className="fa fa-pencil-square-o"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <input
                                        ref={inputRef}
                                        value={tempValue}
                                        onChange={(e) =>
                                          setTempValue(e.target.value)
                                        }
                                        style={{
                                          fontSize: "18px",
                                          fontWeight: 500,
                                          letterSpacing: "0.035em",
                                          color: "#2196f3",
                                          borderLeft: "3.75px solid #2196f3",
                                          paddingLeft: "10px",
                                          lineHeight: "0.9em",
                                          border: "none",
                                          outline: "none",
                                          background: "transparent",
                                          width: "70px",
                                        }}
                                      />
                                    </>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div
                              className="insights-box"
                              style={{ height: "60px" }}
                            >
                              <div className="insights-box-header clearfix whitespace-nowrap font-medium">
                                <h4 style={{ fontSize: "18px" }}>
                                  Debtor Status
                                </h4>
                                <img
                                  src="assets/images/customer-icon.png"
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <div
                                className="insights-box-count flex gap-7 flex-col px-4 py-4"
                                style={{
                                  backgroundColor: "#EEF2F5",
                                  marginTop: "20px",
                                  height: "80px",
                                  // borderRadius: "8px",
                                }}
                              >
                                <h2 style={{ fontSize: "18px" }}>
                                  {callInsight?.collection_params
                                    ?.debtor_status || "NA"}
                                </h2>
                                <span className="flex justify-between items-center">
                                  {editingKey !== "debtor" ? (
                                    <>
                                      <h2 style={{ fontSize: "14px" }}>
                                        {values.debtor}
                                      </h2>

                                      <span
                                        className="cursor-pointer"
                                        onClick={() => {
                                          setTempValue(
                                            String(values.debtor ?? ""),
                                          );
                                          startEdit("debtor");
                                        }}
                                      >
                                        <i
                                          className="fa fa-pencil-square-o"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <input
                                        ref={inputRef}
                                        value={tempValue}
                                        onChange={(e) =>
                                          setTempValue(e.target.value)
                                        }
                                        style={{
                                          fontSize: "18px",
                                          fontWeight: 500,
                                          letterSpacing: "0.035em",
                                          color: "#2196f3",
                                          borderLeft: "3.75px solid #2196f3",
                                          paddingLeft: "10px",
                                          lineHeight: "0.9em",
                                          border: "none",
                                          outline: "none",
                                          background: "transparent",
                                          width: "160px",
                                        }}
                                      />
                                    </>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div>
                          {/* <div className="flex-1">
                            <div
                              className="insights-box"
                              style={{ height: "60px" }}
                            >
                              <div className="insights-box-header clearfix font-medium">
                                <h4 style={{ fontSize: "18px" }}>Payment </h4>
                                <img
                                  src="assets/images/agreeability-icon.png"
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <div
                                className="insights-box-count flex gap-7 flex-col px-4 py-4"
                                style={{
                                  backgroundColor: "#EEF2F5",
                                  marginTop: "20px",
                                  // borderRadius: "8px",
                                  height: "80px",
                                }}
                              >
                                <h2 style={{ fontSize: "18px" }}>
                                  {callInsight?.collection_params?.payment_pct
                                    ? "Positive"
                                    : "Negative"}
                                </h2>
                                <span className="flex justify-between items-center">
                                  {editingKey !== "payment" ? (
                                    <>
                                      <h2 style={{ fontSize: "14px" }}>
                                        {values.payment}
                                      </h2>

                                      <span
                                        className="cursor-pointer"
                                        onClick={() => {
                                          setTempValue(
                                            String(values.payment ?? ""),
                                          );
                                          startEdit("payment");
                                        }}
                                      >
                                        <i
                                          className="fa fa-pencil-square-o"
                                          aria-hidden="true"
                                        ></i>
                                      </span>
                                    </>
                                  ) : (
                                    <>
                                      <select
                                        ref={inputRef}
                                        value={tempValue}
                                        onChange={(e) =>
                                          setTempValue(e.target.value)
                                        }
                                        style={{
                                          fontSize: "14px",
                                          fontWeight: 500,
                                          letterSpacing: "0.035em",
                                          color: "#2196f3",
                                          borderBottom: "1px solid #2196f3",
                                          paddingLeft: "10px",
                                          lineHeight: "0.9em",
                                          // border: "1px solid #2196f3",
                                          // outline: "1px solid red",
                                          background: "transparent",
                                          width: "120px",
                                          // appearance: "none",
                                        }}
                                        className="bg-transparent"
                                      >
                                        <option value="Positive">
                                          Positive
                                        </option>
                                        <option value="Negative">
                                          Negative
                                        </option>
                                      </select>
                                    </>
                                  )}
                                </span>
                              </div>
                            </div>
                          </div> */}

                          {editingKey && (
                            <div className="w-full flex justify-end mt-4 pr-2">
                              <div className="flex gap-3">
                                <button
                                  className="px-4 py-2 bg-blue-900 text-white rounded"
                                  onMouseDown={(e) => e.preventDefault()}
                                  onClick={handleSave}
                                >
                                  Save
                                </button>
                                <button
                                  className="px-4 py-2 rounded"
                                  style={{ border: "1px solid gray" }}
                                  onMouseDown={(e) => e.preventDefault()}
                                  onClick={handleCancel}
                                >
                                  Cancel
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="flex flex-wrap gap-2">
                          <div className="flex-1">
                            <div className="insights-box">
                              <div className="insights-box-header clearfix">
                                <h4>
                                  {useCase == "Maya Bank Collections"
                                    ? "Audit score"
                                    : "CX Score"}{" "}
                                </h4>
                                <img
                                  src="assets/images/cx-icon.png"
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <div className="insights-box-count">
                                <h2>{callInsight.cx_score} &nbsp;%</h2>
                              </div>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="insights-box">
                              <div className="insights-box-header clearfix">
                                <h4>
                                  Problem <br />
                                  Found
                                </h4>
                                <img
                                  src="assets/images/customer-icon.png"
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <div className="insights-box-count">
                                <h2>{callInsight.problen ? "Yes" : "No"}</h2>
                              </div>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="insights-box">
                              <div className="insights-box-header clearfix">
                                <h4>
                                  Customer <br /> Intent
                                </h4>
                                <img
                                  src="assets/images/agreeability-icon.png"
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <div className="insights-box-count">
                                <h2 style={{ fontSize: "25px" }}>
                                  {callInsight.intent > 0
                                    ? "Positive"
                                    : "Negative"}
                                </h2>
                              </div>
                            </div>
                          </div>
                          <div className="flex-1">
                            <div className="insights-box">
                              <div className="insights-box-header clearfix">
                                <h4>Resolution</h4>
                                <img
                                  src="assets/images/resolution-icon.png"
                                  className="img-responsive"
                                  alt=""
                                />
                              </div>
                              <div className="insights-box-count">
                                <h2>{callInsight.resolution ? "Yes" : "No"}</h2>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  {useCase == "Insurance - PCVC Verification" ? (
                    <div className="white-box-global px-12 py-4">
                      <div className="new-box mb-3">
                        <h3>Critical</h3>
                        {/* {console.log("hy ram", match)} */}
                      </div>
                      <div
                        className="flex flex-wrap gap-2  justify-start  mb-3 
                        
                        "
                        style={{ paddingLeft: "25px", paddingRight: "25px" }}
                      >
                        <div
                          className=" p-4 mr-10  critical-per"
                          style={{ width: "250px" }}
                        >
                          Business : {"-"}
                        </div>
                        <div
                          className=" p-4 critical-per"
                          style={{ width: "250px" }}
                        >
                          Customer : {"-"}
                        </div>
                        <div
                          className=" p-4 mt-2 mr-10  critical-per"
                          style={{ width: "250px" }}
                        >
                          Regulatory : {"-"}
                        </div>
                        <div
                          className=" p-4 mt-2  critical-per"
                          style={{ width: "250px" }}
                        >
                          Non Critical : {"-"}
                        </div>
                      </div>
                    </div>
                  ) : !storage.getItem("usecase").includes("Collections") ? (
                    <div className="white-box-global">
                      {!storage.getItem("usecase").includes("Collections") && (
                        <div className="flex flex-wrap gap-2">
                          <div
                            className="flex flex-wrap gap-2  mb-3"
                            style={{
                              paddingLeft: "25px",
                              paddingRight: "25px",
                            }}
                          >
                            <div className=" p-4   mr-10  critical-per1 whitespace-nowrap flex-1">
                              Agent Sentiment :{" "}
                              {callInsight.agent_sentiment > 0 ? (
                                <i
                                  className="fa fa-plus-circle"
                                  style={{ color: "green" }}
                                  aria-hidden="true"
                                />
                              ) : (
                                <i
                                  className="fa fa-minus-circle"
                                  style={{ color: "red" }}
                                  aria-hidden="true"
                                />
                              )}
                              &nbsp;
                              {Math.abs(
                                (callInsight.agent_sentiment * 100).toFixed(2),
                              )}{" "}
                              %
                            </div>
                            <div className=" p-4 critical-per1 whitespace-nowrap flex-1">
                              Customer Sentiment :{" "}
                              {callInsight.customer_sentiment > 0 ? (
                                <i
                                  className="fa fa-plus-circle"
                                  style={{ color: "green" }}
                                  aria-hidden="true"
                                />
                              ) : (
                                <i
                                  className="fa fa-minus-circle"
                                  style={{ color: "red" }}
                                  aria-hidden="true"
                                />
                              )}
                              &nbsp;
                              {Math.abs(
                                (callInsight.customer_sentiment * 100).toFixed(
                                  2,
                                ),
                              )}{" "}
                              %
                            </div>
                          </div>

                          {/* <div className="col-md-6">
                            <div className="wwp-text whitespace-nowrap">
                              <h4>
                                <span>Agent Sentiment : </span>
                                {callInsight.agent_sentiment > 0 ? (
                                  <i
                                    className="fa fa-plus-circle"
                                    style={{ color: "green" }}
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <i
                                    className="fa fa-minus-circle"
                                    style={{ color: "red" }}
                                    aria-hidden="true"
                                  />
                                )}
                                &nbsp;
                                {Math.abs(
                                  (callInsight.agent_sentiment * 100).toFixed(2)
                                )}{" "}
                                %
                              </h4>
                            </div>
                          </div> */}
                          {/* <div className="col-md-6">
                            <div className="wwp-text align-right">
                              <h4>
                                <span>Customer Sentiment : </span>
                                {callInsight.customer_sentiment > 0 ? (
                                  <i
                                    className="fa fa-plus-circle"
                                    style={{ color: "green" }}
                                    aria-hidden="true"
                                  />
                                ) : (
                                  <i
                                    className="fa fa-minus-circle"
                                    style={{ color: "red" }}
                                    aria-hidden="true"
                                  />
                                )}
                                &nbsp;
                                {Math.abs(
                                  (
                                    callInsight.customer_sentiment * 100
                                  ).toFixed(2)
                                )}{" "}
                                %
                              </h4>
                            </div>
                          </div> */}
                        </div>
                      )}
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="white-box-global call-records">
                    <div className="flex flex-wrap gap-2">
                      <div className="flex-1">
                        <div className="white-box-header">
                          <h3>Call Duration : {callInsight.duration}</h3>
                        </div>
                      </div>
                      <div
                        className="flex-1"
                        style={{ padding: "10px", paddingRight: "20px" }}
                      >
                        <input
                          style={{
                            backgroundColor: "#5bc0de",
                            padding: "5px 10px",
                            borderRadius: "5px",
                            color: "white",
                          }}
                          className="pull-right  "
                          type="submit"
                          onClick={play}
                          value={isPlaying ? "Pause" : "Play"}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        height: "250px",
                        paddingLeft: "20px",
                        paddingRight: "20px",
                      }}
                    >
                      {!isPending && (
                        <WaveSurfer
                          plugins={plugins}
                          onMount={handleWSMount}
                          scrollParent="true"
                        >
                          <div id="timeline" />
                          <WaveForm id="waveform" style={{ width: "100%" }}>
                            {regions.map((regionProps) => (
                              <Region
                                onUpdateEnd={handleRegionUpdate}
                                key={regionProps.id}
                                {...regionProps}
                              />
                            ))}
                          </WaveForm>
                        </WaveSurfer>
                      )}
                    </div>

                    {useCase == "Insurance - PCVC Verification" ? (
                      <div className="flex flex-wrap gap-2">
                        <div style={{ textAlign: "center" }}>
                          {speakers &&
                            speakers.map((speaker) => (
                              <>
                                {speaker == "agent" && (
                                  <>
                                    <a
                                      onClick={() =>
                                        regionFilterFun("speaker", "agent")
                                      }
                                      style={{
                                        cursor: "cell",
                                        backgroundColor:
                                          "rgba(255, 196, 226, 0.4)",
                                        fontSize: "15px",
                                        color: "black",
                                        padding: "8px",
                                        borderRadius: "15px",
                                      }}
                                    >
                                      Agent
                                    </a>
                                    &nbsp;
                                  </>
                                )}

                                {speaker == "customer" && (
                                  <>
                                    <a
                                      onClick={() =>
                                        regionFilterFun("speaker", "customer")
                                      }
                                      style={{
                                        cursor: "cell",
                                        backgroundColor:
                                          "rgba(255, 255, 0, 0.4)",
                                        fontSize: "15px",
                                        color: "black",
                                        padding: "8px",
                                        borderRadius: "15px",
                                      }}
                                    >
                                      Customer
                                    </a>
                                    &nbsp;
                                  </>
                                )}
                              </>
                            ))}
                        </div>
                      </div>
                    ) : (
                      <div className="flex flex-wrap gap-2 justify-center">
                        <div style={{ textAlign: "center" }}>
                          {speakers &&
                            speakers.map((speaker) => (
                              <>
                                {speaker == "agent" && (
                                  <>
                                    <a
                                      onClick={() =>
                                        regionFilterFun("speaker", "agent")
                                      }
                                      style={{
                                        cursor: "cell",
                                        backgroundColor:
                                          "rgba(255, 196, 226, 0.4)",
                                        fontSize: "15px",
                                        color: "black",
                                        padding: "8px",
                                        borderRadius: "15px",
                                      }}
                                    >
                                      Agent
                                    </a>
                                    &nbsp;
                                  </>
                                )}

                                {speaker == "customer" && (
                                  <>
                                    <a
                                      onClick={() =>
                                        regionFilterFun("speaker", "customer")
                                      }
                                      style={{
                                        cursor: "cell",
                                        backgroundColor:
                                          "rgba(255, 255, 0, 0.4)",
                                        fontSize: "15px",
                                        color: "black",
                                        padding: "8px",
                                        borderRadius: "15px",
                                      }}
                                    >
                                      Customer
                                    </a>
                                    &nbsp;
                                  </>
                                )}
                              </>
                            ))}
                          <a style={{ fontSize: "20px" }}>
                            &nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;&nbsp;
                          </a>
                          {emotions &&
                            emotions.map((emotion) => (
                              <>
                                {emotion == "Happy" && (
                                  <>
                                    <a
                                      onClick={() =>
                                        regionFilterFun("emotion", "Happy")
                                      }
                                      style={{
                                        cursor: "cell",
                                        backgroundColor: "rgba(0,228,255,0.2)",
                                        fontSize: "15px",
                                        color: "black",
                                        padding: "8px",
                                        borderRadius: "15px",
                                      }}
                                    >
                                      Happy
                                    </a>
                                    &nbsp;
                                  </>
                                )}

                                {emotion == "Fearful" && (
                                  <>
                                    <a
                                      onClick={() =>
                                        regionFilterFun("emotion", "Fearful")
                                      }
                                      style={{
                                        cursor: "cell",
                                        backgroundColor: "rgba(0,64,255,0.2)",
                                        fontSize: "15px",
                                        color: "black",
                                        padding: "8px",
                                        borderRadius: "15px",
                                      }}
                                    >
                                      Fearful
                                    </a>
                                    &nbsp;
                                  </>
                                )}

                                {emotion == "Angry" && (
                                  <>
                                    <a
                                      onClick={() =>
                                        regionFilterFun("emotion", "Angry")
                                      }
                                      style={{
                                        cursor: "cell",
                                        backgroundColor: "rgba(58,255,0,0.2)",
                                        fontSize: "15px",
                                        color: "black",
                                        padding: "8px",
                                        borderRadius: "15px",
                                      }}
                                    >
                                      Angry
                                    </a>
                                    &nbsp;
                                  </>
                                )}

                                {emotion == "Sad" && (
                                  <>
                                    <a
                                      onClick={() =>
                                        regionFilterFun("emotion", "Sad")
                                      }
                                      style={{
                                        cursor: "cell",
                                        backgroundColor: "rgba(255,0,255,0.2)",
                                        fontSize: "15px",
                                        color: "black",
                                        padding: "8px",
                                        borderRadius: "15px",
                                      }}
                                    >
                                      Sad
                                    </a>
                                    &nbsp;
                                  </>
                                )}

                                {emotion == "Calm" && (
                                  <>
                                    <a
                                      onClick={() =>
                                        regionFilterFun("emotion", "Calm")
                                      }
                                      style={{
                                        cursor: "cell",
                                        backgroundColor: "rgba(255,0,0,0.2)",
                                        fontSize: "15px",
                                        color: "black",
                                        padding: "8px",
                                        borderRadius: "15px",
                                      }}
                                    >
                                      Calm
                                    </a>
                                    &nbsp;
                                  </>
                                )}
                              </>
                            ))}
                        </div>
                      </div>
                    )}

                    {/* <Wavesurfer
                                                src={callInsight.audio_file}
                                                position={position}
                                                onPositionChange={handlePositionChange}
                                                onReady={onReadyHandler}
                                                muted={muted}
                                                playing={playing}
                                                zoomLevel={zoomLevel}
                                                options={waveOptions}
                                            >
                                                <Timeline options={timelineOptions} />
                                            </Wavesurfer> */}
                    {/* {!playing && <button className="btn btn-info center-block" onClick={handlePlayPause}><i className="fa fa-play-circle" aria-hidden="true"></i> &nbsp;Play</button>}
                                            {playing && <button className="btn btn-success center-block" onClick={handlePlayPause}><i className="fa fa-pause-circle" aria-hidden="true"></i> &nbsp;Pause</button>} */}
                    <br />
                  </div>
                  <div>
                    <div className="white-box-global analysis-white-box">
                      <div className="white-box-header intent-header flex justify-between">
                        {useCase == "Insurance - PCVC Verification" ? (
                          <h3>Call Analysis</h3>
                        ) : storage
                            .getItem("usecase")
                            .includes("Collections") ? (
                          <h3>Intent</h3>
                        ) : (
                          <h3>Intent Analysis</h3>
                        )}
                        {storage.getItem("usecase").includes("Collections") && (
                          <div className="flex gap-3 items-center">
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                background: "#eef2f5",
                                border: "1px solid #d1d9e0",
                                borderRadius: "10px",
                                padding: "4px 12px",
                                fontSize: "14px",
                                color: "#4a5372",
                                fontWeight: "500",
                              }}
                            >
                              Collection Status:{" "}
                              <span
                                style={{ fontWeight: "700", marginLeft: "4px" }}
                              >
                                {callInsight?.collection_intent?.status ?? "-"}
                              </span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                background: "#eef2f5",
                                border: "1px solid #d1d9e0",
                                borderRadius: "10px",
                                padding: "4px 12px",
                                fontSize: "14px",
                                color: "#4a5372",
                                fontWeight: "500",
                              }}
                            >
                              Stage:{" "}
                              <span
                                style={{ fontWeight: "700", marginLeft: "4px" }}
                              >
                                {callInsight?.collection_intent?.stage ?? "-"}
                              </span>
                            </div>
                          </div>
                        )}
                      </div>
                      {storage.getItem("usecase").includes("Collections") && (
                        <div
                          style={{
                            display: "flex",
                            gap: "12px",
                            padding: "10px 14px",
                            borderBottom: "1px solid #e8ecf0",
                          }}
                        >
                          <div
                            style={{
                              flex: 1,
                              background: "#eef2f5",
                              border: "1px solid #d1d9e0",
                              borderRadius: "8px",
                              padding: "10px 16px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              color: "#4a5372",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            <span>Score</span>
                            <span
                              style={{
                                fontWeight: "700",
                                fontSize: "15px",
                                color: "#1e3a5f",
                              }}
                            >
                              {callInsight?.call_collection_score ?? "-"}
                            </span>
                          </div>
                          <div
                            style={{
                              flex: 1,
                              background: "#eef2f5",
                              border: "1px solid #d1d9e0",
                              borderRadius: "8px",
                              padding: "10px 16px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              color: "#4a5372",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            <span>Ideal Score Range</span>
                            <span
                              style={{
                                fontWeight: "700",
                                fontSize: "15px",
                                color: "#1e3a5f",
                              }}
                            >
                              {callInsight?.collection_intent
                                ?.ideal_score_range ?? "-"}
                            </span>
                          </div>
                        </div>
                      )}
                      {storage.getItem("usecase").includes("Collections") && (
                        <div
                          style={{
                            display: "flex",
                            gap: "12px",
                            padding: "10px 14px",
                            borderBottom: "1px solid #e8ecf0",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              flex: 1,
                              background: "#eef2f5",
                              border: "1px solid #d1d9e0",
                              borderRadius: "8px",
                              padding: "10px 16px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              color: "#4a5372",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            <span>Collected Amount</span>
                            <span
                              style={{
                                fontWeight: "700",
                                fontSize: "15px",
                                color: "#1e3a5f",
                              }}
                            >
                              {callInsight?.collection_intent
                                ?.collected_amount ?? "-"}
                            </span>
                          </div>
                          <div
                            style={{
                              flex: 1,
                              background: "#eef2f5",
                              border: "1px solid #d1d9e0",
                              borderRadius: "8px",
                              padding: "10px 16px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              color: "#4a5372",
                              fontSize: "14px",
                              fontWeight: "500",
                            }}
                          >
                            <span>Target Amount</span>
                            <span
                              style={{
                                fontWeight: "700",
                                fontSize: "15px",
                                color: "#1e3a5f",
                              }}
                            >
                              {callInsight?.collection_intent?.target_amount ??
                                "-"}
                            </span>
                          </div>
                          <input
                            type="file"
                            accept=".xlsx,.xls,.csv"
                            ref={importFileRef}
                            style={{ display: "none" }}
                            onChange={(e) => {
                              const file = e.target.files[0];
                              if (file) handleImportExcel(file);
                              e.target.value = "";
                            }}
                          />
                          <button
                            onClick={() => importFileRef.current?.click()}
                            disabled={isImporting}
                            style={{
                              backgroundColor: isImporting
                                ? "#94a3b8"
                                : "#5BC0DE",
                              color: "white",
                              border: "none",
                              borderRadius: "8px",
                              padding: "10px 18px",
                              fontSize: "13px",
                              fontWeight: "600",
                              cursor: isImporting ? "not-allowed" : "pointer",
                              whiteSpace: "nowrap",
                              flexShrink: 0,
                            }}
                          >
                            {isImporting ? "Importing..." : "Import"}
                          </button>
                        </div>
                      )}
                      <div
                        className="sentiment-body"
                        style={{
                          maxHeight: "890px",
                          overflowY: "auto",
                          padding: "14px 0px 14px 14px",
                        }}
                      >
                        <h4 style={{ paddingLeft: "5px" }}>Customer</h4>

                        <div className="wrapperinfo-table">
                          {storage
                            .getItem("usecase")
                            .includes("Collections") ? (
                            <>
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Classification
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Attributes
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Score (/100) | Value
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Avg Score
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {/* tonal section */}
                                  {(() => {
                                    const attrs =
                                      callInsight?.collection_intent?.customer
                                        ?.classifications?.tonal?.attributes ??
                                      [];
                                    const totalScore =
                                      attrs.length > 0
                                        ? Math.round(
                                            (attrs.reduce(
                                              (sum, item) =>
                                                sum + (item.score || 0),
                                              0,
                                            ) /
                                              (attrs.length * 100)) *
                                              100,
                                          ) + "/100"
                                        : "-";
                                    return attrs.map((item, idx) => (
                                      <tr key={idx}>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Tonal
                                          </td>
                                        )}
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {item.attribute}
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {item.score}
                                        </td>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {totalScore}
                                          </td>
                                        )}
                                      </tr>
                                    ));
                                  })()}

                                  {/* textual section */}
                                  {(() => {
                                    const attrs =
                                      callInsight?.collection_intent?.customer
                                        ?.classifications?.textual
                                        ?.attributes ?? [];
                                    const totalScore =
                                      attrs.length > 0
                                        ? Math.round(
                                            (attrs.reduce(
                                              (sum, item) =>
                                                sum + (item.score || 0),
                                              0,
                                            ) /
                                              (attrs.length * 100)) *
                                              100,
                                          ) + "/100"
                                        : "-";
                                    return attrs.map((item, idx) => (
                                      <tr key={idx}>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Textual
                                          </td>
                                        )}
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {item.attribute}
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {item.score}
                                        </td>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {totalScore}
                                          </td>
                                        )}
                                      </tr>
                                    ));
                                  })()}

                                  {/* mathematical section */}
                                  {(() => {
                                    const attrs =
                                      callInsight?.collection_intent?.customer
                                        ?.classifications?.mathematical
                                        ?.attributes ?? [];
                                    const totalScore =
                                      callInsight?.collection_intent?.customer
                                        ?.classifications?.mathematical
                                        ?.total_score ?? "-";
                                    return attrs.map((item, idx) => (
                                      <tr key={idx}>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Mathematical
                                          </td>
                                        )}
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {item.attribute}
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {item.score}
                                        </td>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {totalScore}
                                          </td>
                                        )}
                                      </tr>
                                    ));
                                  })()}

                                  {/* data points section */}
                                  {(() => {
                                    const staticData =
                                      callInsight?.static_datapoints
                                        ?.customer || {};
                                    const attrs = Object.entries(
                                      staticData,
                                    ).filter(([key]) => key !== "intent_score");
                                    if (attrs.length === 0) return null;

                                    const totalScore =
                                      staticData.intent_score != null
                                        ? staticData.intent_score + "/100"
                                        : "-";
                                    return attrs.map(([key, value], idx) => (
                                      <tr key={idx}>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Data Points
                                          </td>
                                        )}
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          {key.replace(/_/g, " ")}
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {value === "NOT MENTIONED" ? (
                                            <i
                                              className="fa fa-times"
                                              aria-hidden="true"
                                              style={{
                                                backgroundColor: "red",
                                                color: "white",
                                                borderRadius: "50%",
                                                padding: "4px",
                                                fontSize: "10px",
                                                width: "18px",
                                                height: "18px",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            ></i>
                                          ) : (
                                            value
                                          )}
                                        </td>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {totalScore}
                                          </td>
                                        )}
                                      </tr>
                                    ));
                                  })()}
                                </tbody>
                              </table>
                              <div
                                style={{
                                  marginTop: "10px",
                                  fontSize: "12px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                }}
                              >
                                <i
                                  className="fa fa-times"
                                  aria-hidden="true"
                                  style={{
                                    backgroundColor: "red",
                                    color: "white",
                                    borderRadius: "50%",
                                    padding: "4px",
                                    fontSize: "10px",
                                    width: "18px",
                                    height: "18px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                ></i>
                                <span>Not Mentioned</span>
                              </div>
                              <h4
                                style={{
                                  paddingLeft: "5px",
                                  marginTop: "10px",
                                }}
                              >
                                Agent
                              </h4>

                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Classification
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Attributes
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Score (/100) | Value
                                    </th>
                                    <th
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "8px",
                                        textAlign: "center",
                                      }}
                                    >
                                      Avg Score
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {/* tonal section */}
                                  {(() => {
                                    const attrs =
                                      callInsight?.collection_intent?.agent
                                        ?.classifications?.tonal?.attributes ??
                                      [];
                                    const totalScore =
                                      attrs.length > 0
                                        ? Math.round(
                                            (attrs.reduce(
                                              (sum, item) =>
                                                sum + (item.score || 0),
                                              0,
                                            ) /
                                              (attrs.length * 100)) *
                                              100,
                                          ) + "/100"
                                        : "-";
                                    return attrs.map((item, idx) => (
                                      <tr key={idx}>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Tonal
                                          </td>
                                        )}
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {item.attribute}
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {item.score}
                                        </td>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {totalScore}
                                          </td>
                                        )}
                                      </tr>
                                    ));
                                  })()}

                                  {/* textual section */}
                                  {(() => {
                                    const attrs =
                                      callInsight?.collection_intent?.agent
                                        ?.classifications?.textual
                                        ?.attributes ?? [];
                                    const totalScore =
                                      attrs.length > 0
                                        ? Math.round(
                                            (attrs.reduce(
                                              (sum, item) =>
                                                sum + (item.score || 0),
                                              0,
                                            ) /
                                              (attrs.length * 100)) *
                                              100,
                                          ) + "/100"
                                        : "-";
                                    return attrs.map((item, idx) => (
                                      <tr key={idx}>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Textual
                                          </td>
                                        )}
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {item.attribute}
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {item.score}
                                        </td>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {totalScore}
                                          </td>
                                        )}
                                      </tr>
                                    ));
                                  })()}

                                  {/* mathematical section */}
                                  {(() => {
                                    const attrs =
                                      callInsight?.collection_intent?.agent
                                        ?.classifications?.mathematical
                                        ?.attributes ?? [];
                                    const totalScore =
                                      callInsight?.collection_intent?.agent
                                        ?.classifications?.mathematical
                                        ?.total_score ?? "-";
                                    return attrs.map((item, idx) => (
                                      <tr key={idx}>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Mathematical
                                          </td>
                                        )}
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {item.attribute}
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {item.score}
                                        </td>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {totalScore}
                                          </td>
                                        )}
                                      </tr>
                                    ));
                                  })()}

                                  {/* data points section */}
                                  {(() => {
                                    const staticData =
                                      callInsight?.static_datapoints?.agent ||
                                      {};
                                    const attrs = Object.entries(
                                      staticData,
                                    ).filter(([key]) => key !== "intent_score");
                                    if (attrs.length === 0) return null;

                                    const totalScore =
                                      staticData.intent_score != null
                                        ? staticData.intent_score + "/100"
                                        : "-";
                                    return attrs.map(([key, value], idx) => (
                                      <tr key={idx}>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            Data Points
                                          </td>
                                        )}
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          {key.replace(/_/g, " ")}
                                        </td>
                                        <td
                                          style={{
                                            border: "1px solid #ccc",
                                            padding: "8px",
                                            textAlign: "center",
                                          }}
                                        >
                                          {value === "NOT MENTIONED" ? (
                                            <i
                                              className="fa fa-times"
                                              aria-hidden="true"
                                              style={{
                                                backgroundColor: "red",
                                                color: "white",
                                                borderRadius: "50%",
                                                padding: "4px",
                                                fontSize: "10px",
                                                width: "18px",
                                                height: "18px",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                              }}
                                            ></i>
                                          ) : (
                                            value
                                          )}
                                        </td>
                                        {idx === 0 && (
                                          <td
                                            rowSpan={attrs.length}
                                            style={{
                                              verticalAlign: "middle",
                                              border: "1px solid #ccc",
                                              padding: "8px",
                                              textAlign: "center",
                                            }}
                                          >
                                            {totalScore}
                                          </td>
                                        )}
                                      </tr>
                                    ));
                                  })()}
                                </tbody>
                              </table>
                              <div
                                style={{
                                  marginTop: "10px",
                                  fontSize: "12px",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "5px",
                                  marginBottom: "15px",
                                }}
                              >
                                <i
                                  className="fa fa-times"
                                  aria-hidden="true"
                                  style={{
                                    backgroundColor: "red",
                                    color: "white",
                                    borderRadius: "50%",
                                    padding: "4px",
                                    fontSize: "10px",
                                    width: "18px",
                                    height: "18px",
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                ></i>
                                <span>Not Mentioned</span>
                              </div>
                            </>
                          ) : (
                            <table>
                              <thead>
                                <tr>
                                  <th>Parameters</th>
                                  <th>Agent</th>
                                  <th>Customer</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr>
                                  <td>Pitch Scale-High & Low </td>
                                  <td>{agentVariance}</td>
                                  <td>{customerVariance}</td>
                                </tr>
                                <tr>
                                  <td>Loudness</td>
                                  <td>{callInsight?.loudness[0].loudness} %</td>
                                  <td>{callInsight?.loudness[1].loudness} %</td>
                                </tr>
                                <tr>
                                  <td>Positive Disposition</td>
                                  <td>
                                    {callInsight?.spectral_flux?.[0]
                                      ?.positive_disposition || 0}{" "}
                                    %
                                  </td>
                                  <td>
                                    {callInsight?.spectral_flux?.[1]
                                      ?.spectral_flux || 0}{" "}
                                    %
                                  </td>
                                </tr>

                                <tr>
                                  <td>Negative Disposition</td>
                                  <td>
                                    {callInsight?.negative_disposition?.[0]
                                      ?.spectral_flux || 0}{" "}
                                    %
                                  </td>
                                  <td>
                                    {callInsight?.spectral_flux?.[1]
                                      ?.spectral_flux || 0}{" "}
                                    %
                                  </td>
                                </tr>
                                {storage.getItem("role") === "Master" && (
                                  <tr>
                                    <td>Conversation Predictability</td>
                                    <td>
                                      {callInsight?.entropy[0].entropy}&nbsp;%
                                    </td>
                                    <td>
                                      {callInsight?.entropy[1].entropy}&nbsp;%
                                    </td>
                                  </tr>
                                )}

                                <tr>
                                  <td>Arguments Or Interruptions </td>
                                  <td>
                                    {
                                      callInsight?.zero_cross_rate[0]
                                        .zero_cross_rate
                                    }{" "}
                                    %
                                  </td>
                                  <td>
                                    {
                                      callInsight?.zero_cross_rate[1]
                                        .zero_cross_rate
                                    }{" "}
                                    %
                                  </td>
                                </tr>
                                {/* <tr>
                              <td>Positive Disposition</td>
                              <td colSpan="2" className="ZCRtd">
                                {callInsight.tone_result.agreeableness}&nbsp;%
                              </td>
                            </tr> */}
                                {/* <tr>
                              <td>Negative Disposition</td>
                              <td colSpan="2" className="ZCRtd">
                                {callInsight.tone_result.disagreeableness}
                                &nbsp;%
                              </td>
                            </tr> */}
                                <tr>
                                  <td>Decibels</td>
                                  <td>{callInsight?.energy[0].energy} db</td>
                                  <td>{callInsight?.energy[1].energy} db</td>
                                </tr>

                                {expand &&
                                  (storage
                                    .getItem("role")
                                    .includes("Master") ? (
                                    <>
                                      {expandedParameters?.map((e) => (
                                        <tr>
                                          <td>{e?.parametername}</td>
                                          <td>{e?.agent} %</td>
                                          <td>{e?.customer} %</td>
                                        </tr>
                                      ))}
                                    </>
                                  ) : (
                                    <>
                                      {expandedParameters
                                        ?.filter((e) => e.viewForAgent === true)
                                        .map((e) => (
                                          <tr>
                                            <td>{e?.parametername}</td>
                                            <td>{e?.agent} %</td>
                                            <td>{e?.customer} %</td>
                                          </tr>
                                        ))}
                                    </>
                                  ))}
                                <tr
                                  className=" cursor-pointer"
                                  onClick={() => setExpand(!expand)}
                                >
                                  <td colSpan={3} className="text-center">
                                    <div
                                      className={`flex justify-center text-blue-700 text-2xl`}
                                    >
                                      {expand ? "See Less" : "See more"}
                                    </div>
                                  </td>
                                </tr>
                                {useCase !== "Insurance - PCVC Verification" ? (
                                  <tr>
                                    <td>
                                      <h4>Text</h4>
                                    </td>
                                  </tr>
                                ) : (
                                  ""
                                )}

                                {useCase !== "Insurance - PCVC Verification" ? (
                                  <tr>
                                    <td>Sentiment %</td>
                                    <td>
                                      {(
                                        callInsight.agent_sentiment * 100
                                      ).toFixed(2)}{" "}
                                      &nbsp;%
                                    </td>
                                    <td>
                                      {(
                                        callInsight.customer_sentiment * 100
                                      ).toFixed(2)}
                                      &nbsp;%
                                    </td>
                                  </tr>
                                ) : (
                                  ""
                                )}
                                {(useCase !== "Insurance - PCVC Verification" &&
                                  useCase !==
                                    "Third Party Collection Agency") ||
                                useCase !== "Banking Collections PCVC" ? (
                                  <tr>
                                    <td>Sentiment Keywords</td>
                                    <td colSpan="2">
                                      {callInsight.sentiment_keywords.map(
                                        (keyword) => (
                                          <a>{keyword}</a>
                                        ),
                                      )}
                                    </td>
                                  </tr>
                                ) : (
                                  ""
                                )}

                                <tr>
                                  <td>Top Keywords</td>
                                  <td colSpan="2">
                                    {callInsight.keywords.map((keyword) => (
                                      <a className=" hover:none">{keyword}</a>
                                    ))}
                                  </td>
                                </tr>
                              </tbody>
                              <br />
                            </table>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* <div
                      className="white-box-global analysis-white-box"
                      style={{ marginTop: "20px" }}
                    >
                      <div className="white-box-header intent-header">
                        <h3>Live Call Prompts</h3>
                      </div>
                      <div
                        className="sentiment-body"
                        style={{
                          padding: "16px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "0",
                        }}
                      >
      
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            padding: "8px 12px",
                            marginBottom: "14px",
                            background: "#f9fafb",
                            borderRadius: "8px",
                            border: "1px solid #f3f4f6",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              color: "#6b7280",
                              fontWeight: "500",
                            }}
                          >
                            Total Number of Prompts:
                          </span>
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color: "#1f2937",
                            }}
                          >
                            12
                          </span>
                        </div>

           
                        <div
                          style={{
                            marginBottom: "14px",
                            background: "#fff",
                            border: "1px solid #e5e7eb",
                            borderRadius: "10px",
                            padding: "14px 16px",
                          }}
                        >
                          <p
                            style={{
                              margin: "0 0 10px",
                              fontSize: "12px",
                              fontWeight: "600",
                              color: "#6b7280",
                              textTransform: "uppercase",
                              letterSpacing: "0.05em",
                            }}
                          >
                            Prompts Analysis — Key Takeout
                          </p>
                          <div
                            style={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: "6px",
                            }}
                          >
                            {[
                              "Payment Reminder",
                              "Debt Acknowledgement",
                              "Settlement Offer",
                              "Dispute Raised",
                              "Callback Requested",
                              "Legal Mention",
                              "Promise to Pay",
                            ].map((tag) => (
                              <span
                                key={tag}
                                style={{
                                  background: "#eef2ff",
                                  color: "#4338ca",
                                  border: "1px solid #c7d2fe",
                                  borderRadius: "20px",
                                  padding: "4px 12px",
                                  fontSize: "12px",
                                  fontWeight: "500",
                                }}
                              >
                                {tag}
                              </span>
                            ))}
                          </div>
                        </div>

               
                        <div
                          style={{
                            background: "#fff",
                            border: "1px solid #e5e7eb",
                            borderRadius: "10px",
                            padding: "14px 16px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              marginBottom: "10px",
                            }}
                          >
                            <p
                              style={{
                                margin: 0,
                                fontSize: "12px",
                                fontWeight: "600",
                                color: "#6b7280",
                                textTransform: "uppercase",
                                letterSpacing: "0.05em",
                              }}
                            >
                              Prompt Recommendations
                            </p>
                            <button
                              onClick={() => setShowPromptsModal(true)}
                              style={{
                                background: "#2056FF",
                                color: "#fff",
                                border: "none",
                                borderRadius: "6px",
                                padding: "4px 12px",
                                fontSize: "12px",
                                fontWeight: "600",
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                              }}
                            >
                              View More
                            </button>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "8px",
                            }}
                          >
                            {[
                              {
                                label: "Key Intervention",
                                text: "Offer structured repayment plan to customer.",
                                color: "#dbeafe",
                                textColor: "#1d4ed8",
                              },
                              {
                                label: "Key Detail",
                                text: "Escalate to senior advisor if dispute persists.",
                                color: "#fce7f3",
                                textColor: "#9d174d",
                              },
                            ].map((item, i) => (
                              <div
                                key={i}
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  gap: "10px",
                                  padding: "8px 10px",
                                  background: "#f9fafb",
                                  borderRadius: "8px",
                                  border: "1px solid #f3f4f6",
                                }}
                              >
                                <span
                                  style={{
                                    background: item.color,
                                    color: item.textColor,
                                    fontSize: "10px",
                                    fontWeight: "700",
                                    borderRadius: "10px",
                                    padding: "2px 8px",
                                    whiteSpace: "nowrap",
                                    marginTop: "2px",
                                  }}
                                >
                                  {item.label}
                                </span>
                                <span
                                  style={{
                                    fontSize: "13px",
                                    color: "#374151",
                                    lineHeight: "1.4",
                                  }}
                                >
                                  {item.text}
                                </span>
                              </div>
                            ))}
                            <p
                              style={{
                                margin: "4px 0 0",
                                fontSize: "12px",
                                color: "#9ca3af",
                                textAlign: "right",
                              }}
                            >
                              + 3 more — click{" "}
                              <em
                                style={{
                                  color: "#2056FF",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                                onClick={() => setShowPromptsModal(true)}
                              >
                                View More
                              </em>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div> */}

                    {showPromptsModal && (
                      <div
                        style={{
                          position: "fixed",
                          inset: 0,
                          background: "rgba(0,0,0,0.45)",
                          zIndex: 9999,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => setShowPromptsModal(false)}
                      >
                        <div
                          style={{
                            background: "#fff",
                            borderRadius: "12px",
                            padding: "28px 32px",
                            width: "520px",
                            maxWidth: "90vw",
                            maxHeight: "80vh",
                            overflowY: "auto",
                            boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
                            position: "relative",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            onClick={() => setShowPromptsModal(false)}
                            style={{
                              position: "absolute",
                              top: "14px",
                              right: "18px",
                              background: "none",
                              border: "none",
                              fontSize: "22px",
                              cursor: "pointer",
                              color: "#6b7280",
                            }}
                          >
                            &times;
                          </button>
                          <h3
                            style={{
                              fontSize: "18px",
                              fontWeight: "700",
                              marginBottom: "16px",
                              color: "#1e293b",
                            }}
                          >
                            Prompt Recommendations
                          </h3>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "14px",
                            }}
                          >
                            {[
                              {
                                title: "Callback Scheduling",
                                detail:
                                  "If customer is unable to discuss, schedule a callback at their preferred time and update the CRM with next action.",
                                type: "Key Intervention",
                              },
                              {
                                title: "Escalation to Senior Advisor",
                                detail:
                                  "If customer disputes the amount, escalate to a senior advisor within 24 hours and log dispute ticket in CRM.",
                                type: "Key Intervention",
                              },

                              {
                                title: "Settlement Offer",
                                detail:
                                  "Provide one-time settlement at 85% of outstanding amount if customer commits to payment within 7 days.",
                                type: "Key Detail",
                              },
                            ].map((rec, idx) => (
                              <div
                                key={idx}
                                style={{
                                  background: "#f8fafc",
                                  border: "1px solid #e2e8f0",
                                  borderRadius: "8px",
                                  padding: "14px 16px",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                    marginBottom: "6px",
                                  }}
                                >
                                  <span
                                    style={{
                                      fontSize: "13px",
                                      fontWeight: "700",
                                      color: "#1e293b",
                                    }}
                                  >
                                    {idx + 1}. {rec.title}
                                  </span>
                                  <span
                                    style={{
                                      background:
                                        rec.type === "Key Intervention"
                                          ? "#dbeafe"
                                          : "#fce7f3",
                                      color:
                                        rec.type === "Key Intervention"
                                          ? "#1d4ed8"
                                          : "#9d174d",
                                      borderRadius: "10px",
                                      padding: "1px 10px",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                    }}
                                  >
                                    {rec.type}
                                  </span>
                                </div>
                                <p
                                  style={{
                                    fontSize: "13px",
                                    color: "#475569",
                                    margin: 0,
                                    lineHeight: "1.5",
                                  }}
                                >
                                  {rec.detail}
                                </p>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div>
                    <div
                      className="transcription-white-global"
                      style={{ paddingBottom: "10px" }}
                    >
                      <div className="transcription-box">
                        <div className="transcription-header clearfix">
                          <h4>Dataklout Transcription</h4>
                          <div className="toggle-switch">
                            <label>
                              {isLanguageEnglish && "English"}
                              {!isLanguageEnglish &&
                                displayEnglish &&
                                "English"}
                              {!isLanguageEnglish &&
                                !displayEnglish &&
                                callInsight.language}
                            </label>
                            {callInsight.language !== "English" && (
                              <div className="toggle-switch-intregrate">
                                <input
                                  type="checkbox"
                                  id="switch"
                                  onChange={() => {
                                    setDisplayEnglish(!displayEnglish);
                                    english = !english;
                                  }}
                                />{" "}
                                <label htmlFor="switch"></label>
                              </div>
                            )}
                          </div>
                        </div>
                        <div
                          className="transcription-scrollable "
                          style={{
                            height:
                              useCase === "Third Party Collection Agency" ||
                              useCase.includes("Collections")
                                ? "274px"
                                : "",
                          }}
                        >
                          {isPlaying ? (
                            <div id="transcriptionDiv"></div>
                          ) : (
                            <div className="transcription-info-wrapper clearfix">
                              {callInsight.speech.map((transcription) =>
                                transcription.speaker === "agent" ? (
                                  <div className="transcription-customer-section clearfix flex items-center gap-8">
                                    <h4>
                                      {transcription.speaker_name.split(
                                        " ",
                                      )[0] || "Agent"}
                                    </h4>
                                    <div className="customer-info-right">
                                      <span>
                                        {formatTime(transcription.startTime)}
                                      </span>
                                      {displayEnglish ? (
                                        <p>
                                          <Highlighter
                                            highlightClassName="YourHighlightClass"
                                            searchWords={[callInsight.product]}
                                            autoEscape={true}
                                            textToHighlight={
                                              transcription.dialogue
                                            }
                                          />
                                        </p>
                                      ) : (
                                        <p>{transcription.early_dialogue}</p>
                                      )}
                                      <span>
                                        {formatTime(transcription.endTime)}
                                      </span>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="transcription-customer-section clearfix flex items-center gap-10">
                                    <h4>
                                      {transcription.speaker_name.split(
                                        " ",
                                      )[0] || "Customer"}
                                    </h4>
                                    <div className="customer-info-right">
                                      <span>
                                        {formatTime(transcription.startTime)}
                                      </span>
                                      {displayEnglish ? (
                                        <p>
                                          <Highlighter
                                            highlightClassName="YourHighlightClass"
                                            searchWords={[callInsight.product]}
                                            autoEscape={true}
                                            textToHighlight={
                                              transcription.dialogue
                                            }
                                          />
                                        </p>
                                      ) : (
                                        <p>{transcription.early_dialogue}</p>
                                      )}
                                      <span>
                                        {formatTime(transcription.endTime)}
                                      </span>
                                    </div>
                                  </div>
                                ),
                              )}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`white-box-global keyword-white-box`}
                    style={{ padding: "18px" }}
                  >
                    <div
                      className="white-box-header"
                      style={{ padding: "0px" }}
                    >
                      <h3>Transcription Score</h3>
                    </div>
                    <div className=" flex flex-wrap mt-4 gap-6">
                      <span
                        className=" text-3xl font-medium  bg-gray-100 py-4 px-6 rounded"
                        style={{ width: "48%" }}
                      >
                        Dataklout : {reviewTranscription?.data_klout_score} %
                      </span>
                      <span
                        className=" text-3xl font-medium bg-gray-100 py-4 px-6 rounded"
                        style={{ width: "48%" }}
                      >
                        Reviewer :
                        {Math.trunc(reviewTranscription?.reviewer_score)} %
                      </span>
                    </div>
                  </div>

                  {/* edit transcription section */}
                  {/* Wrapper: groups Reviewer Transcription + Notes as one Masonry column item */}
                  <div>
                    {/* Reviewer Transcription box removed */}
                    {false && (
                      <div
                        className="transcription-white-global"
                        style={{ paddingBottom: "10px" }}
                      >
                        <div className="transcription-box">
                          <div className="transcription-header clearfix">
                            <h4>Reviewer Transcription</h4>
                            <div className="toggle-switch">
                              <label>
                                {reviewerEnglish
                                  ? "English"
                                  : callInsight?.language}
                              </label>

                              {callInsight?.language !== "English" && (
                                <div className="toggle-switch-intregrate">
                                  <input
                                    type="checkbox"
                                    id="switch-reviewer"
                                    checked={reviewerEnglish}
                                    onChange={() =>
                                      setReviewerEnglish((prev) => !prev)
                                    }
                                    disabled={isEditingAll}
                                  />
                                  <label
                                    htmlFor="switch-reviewer"
                                    style={
                                      isEditingAll
                                        ? {
                                            pointerEvents: "none",
                                            opacity: 0.5,
                                          }
                                        : {}
                                    }
                                  ></label>
                                </div>
                              )}
                            </div>
                          </div>
                          <div
                            className="transcription-scrollable"
                            style={{
                              height:
                                useCase === "Third Party Collection Agency" ||
                                useCase === "Banking Collections PCVC"
                                  ? "320px"
                                  : "",
                              position: "relative",
                              overflow: "auto",
                            }}
                          >
                            <div className="transcription-info-wrapper clearfix">
                              {isReviewTranscriptionPending ? (
                                <div
                                  className="empty-call"
                                  style={{ height: "300px" }}
                                >
                                  <ClipLoader color="#2056FF" size="50px" />
                                </div>
                              ) : (
                                (editableTranscriptions || []).map(
                                  (item, index) => (
                                    <div
                                      className="transcription-customer-section clearfix flex items-center gap-8"
                                      key={index}
                                    >
                                      <h4>
                                        {item.speaker_name.split(" ")[0] ||
                                          (item.speaker === "agent"
                                            ? "Agent"
                                            : "Customer")}
                                      </h4>

                                      <div className="customer-info-right">
                                        <span>
                                          {item?.startTime != null
                                            ? formatTime(item.startTime)
                                            : "N/A"}
                                        </span>

                                        <p
                                          className="transcription-text"
                                          contentEditable={isEditingAll}
                                          suppressContentEditableWarning
                                          ref={(el) => {
                                            if (isEditingAll)
                                              editableRefs.current[index] = el;
                                          }}
                                          onFocus={(e) => {
                                            if (isEditingAll)
                                              placeCaretAtEnd(e.currentTarget);
                                          }}
                                          onBlur={(e) => {
                                            handleLineChange(
                                              index,
                                              e.currentTarget.innerText || "",
                                            );
                                          }}
                                          onClick={(e) => {
                                            const userRole =
                                              storage.getItem("role");
                                            if (
                                              userRole === "Agent" ||
                                              userRole === "Agenth" ||
                                              userRole.includes("Agent")
                                            ) {
                                              return;
                                            }

                                            e.stopPropagation();
                                            setHasChanges(true);

                                            if (!isEditingAll) {
                                              setIsEditingAll(true);

                                              const targetIndex = index;
                                              setTimeout(() => {
                                                const el =
                                                  editableRefs.current[
                                                    targetIndex
                                                  ];
                                                if (el) {
                                                  placeCaretAtEnd(el);
                                                  el.focus();
                                                }
                                              }, 0);
                                            }
                                          }}
                                          style={{
                                            cursor:
                                              storage.getItem("role") ===
                                                "Agent" ||
                                              storage.getItem("role") ===
                                                "Agenth" ||
                                              storage
                                                .getItem("role")
                                                .includes("Agent")
                                                ? "not-allowed"
                                                : isEditingAll
                                                  ? "text"
                                                  : "text",
                                            outline: isEditingAll ? "none" : "",
                                            boxShadow: isEditingAll
                                              ? "none"
                                              : "",
                                            WebkitTapHighlightColor:
                                              isEditingAll ? "transparent" : "",
                                            userSelect: isEditingAll
                                              ? "auto"
                                              : "text",
                                          }}
                                        >
                                          {isEditingAll
                                            ? item?.text ||
                                              item?.early_dialogue ||
                                              item?.dialogue ||
                                              ""
                                            : renderDiff(index, item)}
                                        </p>

                                        <span>
                                          {item?.endTime != null
                                            ? formatTime(item.endTime)
                                            : "N/A"}
                                        </span>
                                      </div>
                                    </div>
                                  ),
                                )
                              )}
                            </div>

                            {isEditingAll && (
                              <div
                                className="transcription-floating-actions"
                                style={{
                                  position: "sticky",
                                  bottom: 0,
                                  right: 0,
                                  display: "flex",
                                  justifyContent: "flex-end",
                                  padding: "12px",
                                  zIndex: 20,
                                  gap: 10,
                                }}
                              >
                                <button
                                  onClick={handleCancelAll}
                                  className="px-6 py-2 bg-gray-400 text-white rounded hover:bg-red-600"
                                >
                                  Cancel
                                </button>

                                <button
                                  onClick={handleSaveAll}
                                  className="px-6 py-2 bg-blue-800 text-white rounded"
                                  style={{
                                    opacity: hasChanges ? 1 : 0.5,
                                    cursor: hasChanges
                                      ? "pointer"
                                      : "not-allowed",
                                  }}
                                >
                                  Save
                                </button>
                              </div>
                            )}
                          </div>
                        </div>

                        <div
                          className="px-6 py-4 flex gap-4  justify-center items-center"
                          style={{ marginTop: "10px" }}
                        >
                          <span
                            className="py-3 px-4 rounded-lg  text-black font-medium"
                            style={{
                              backgroundColor: "rgba(255, 196, 226, 0.4)",
                            }}
                          >
                            {" "}
                            Sentence Changed :{" "}
                            {edithistory?.total_sentences_changes}
                          </span>
                          <span
                            className=" py-3 px-4 rounded-lg  text-black font-medium "
                            style={{
                              backgroundColor: "rgba(255, 255, 0, 0.4)",
                            }}
                          >
                            {" "}
                            Word Changed: {edithistory?.total_words_added}{" "}
                          </span>
                          {/* <span
                        className="py-3 px-4 rounded-lg text-black font-medium flex gap-2 justify-center items-center cursor-pointer relative group"
                        style={{ backgroundColor: "rgba(255,0,0,0.2)" }}
                        onClick={() => setShowHistory(true)}
                      >
                        Version: {edithistory?.version_number}
                        <span className="relative">
                          <img src={info} alt="info-icon" className="w-6 h-6" />
                          <span
                            className="absolute right-1/2 bottom-14 rounded-md bg-gray-100 py-2 px-4 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-all duration-200"
                            style={{ border: "1px solid lightgray" }}
                          >
                            View history
                          </span>
                        </span>
                      </span> */}

                          <span
                            className="py-3 px-4 rounded-lg  text-black font-medium cursor-pointer hover:shadow-md transition-all"
                            style={{
                              backgroundColor: "rgba(0,228,255,0.2)",
                              cursor:
                                edithistory?.version_number > 0
                                  ? "pointer"
                                  : "not-allowed",
                              opacity:
                                edithistory?.version_number > 0 ? 1 : 0.6,
                              position: "relative",
                            }}
                            data-tooltip={
                              edithistory?.version_number > 0
                                ? "See version history"
                                : "No revision done"
                            }
                            onClick={() => {
                              if (edithistory?.version_number > 0) {
                                history.push(
                                  `/call/${callID}/transcription-audit`,
                                  {
                                    displayEnglish: reviewerEnglish,
                                  },
                                );
                              }
                            }}
                          >
                            <style>{`
                          [data-tooltip] {
                            position: relative;
                          }
                          [data-tooltip]::after {
                            content: attr(data-tooltip);
                            position: absolute;
                            bottom: 100%;
                            left: 50%;
                            transform: translateX(-50%);
                            background-color: #1f2937;
                            color: white;
                            padding: 8px 12px;
                            border-radius: 6px;
                            font-size: 13px;
                            white-space: nowrap;
                            opacity: 0;
                            pointer-events: none;
                            transition: opacity 0.2s ease-in-out;
                            margin-bottom: 8px;
                            z-index: 1000;
                            box-shadow: 0 2px 8px rgba(0,0,0,0.15);
                          }
                          [data-tooltip]::before {
                            content: "";
                            position: absolute;
                            bottom: 100%;
                            left: 50%;
                            transform: translateX(-50%);
                            border: 6px solid transparent;
                            border-top-color: #1f2937;
                            opacity: 0;
                            pointer-events: none;
                            transition: opacity 0.2s ease-in-out;
                            margin-bottom: 2px;
                            z-index: 1000;
                          }
                          [data-tooltip]:hover::after,
                          [data-tooltip]:hover::before {
                            opacity: 1;
                          }
                        `}</style>
                            Edited On :{" "}
                            {edithistory?.edited_at
                              ? edithistory?.edited_at?.split(" ")[0]
                              : "Not Edited "}
                            <span className="ml-4 pl-4 border-l border-gray-400">
                              Version: {edithistory?.version_number || 0}
                            </span>
                          </span>
                        </div>
                      </div>
                    )}

                    {/* Top Prompts */}
                    <div
                      className="transcription-white-global"
                      style={{ paddingBottom: "10px" }}
                    >
                      <div className="transcription-box">
                        <div className="transcription-header clearfix">
                          <h4>Top Prompts</h4>
                        </div>
                        <div
                          className="transcription-scrollable"
                          style={{
                            height: "250px",
                            overflowY: "auto",
                            padding: "16px",
                            backgroundColor: "#f9fafb",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "16px",
                              height: "100%",
                            }}
                          >
                            {callInsight?.prompts &&
                            Array.isArray(callInsight.prompts) &&
                            callInsight.prompts.length > 0 ? (
                              callInsight.prompts.map((p, idx) => {
                                const speaker = getPromptSpeaker(p);
                                const speakerStyles = getSpeakerStyles(speaker);
                                const promptTime = getPromptTime(p);
                                const promptText = getPromptText(p);

                                return (
                                  <div
                                    key={idx}
                                    style={{
                                      background: "#ffffff",
                                      border: "1px solid #e5e7eb",
                                      borderRadius: "10px",
                                      padding: "16px",
                                      boxShadow: "0 2px 4px rgba(0,0,0,0.02)",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        marginBottom: "12px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          background: speakerStyles.background,
                                          color: speakerStyles.color,
                                          padding: "4px 10px",
                                          borderRadius: "20px",
                                          fontSize: "12px",
                                          fontWeight: "600",
                                          letterSpacing: "0.5px",
                                        }}
                                      >
                                        {speaker}
                                      </span>
                                      <span
                                        style={{
                                          color: "#64748b",
                                          fontSize: "13px",
                                          fontWeight: "600",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: "6px",
                                        }}
                                      >
                                        <i
                                          className="fa fa-clock-o"
                                          aria-hidden="true"
                                        ></i>{" "}
                                        {promptTime}
                                      </span>
                                    </div>
                                    <p
                                      style={{
                                        margin: 0,
                                        color: "#334155",
                                        fontSize: "14px",
                                        lineHeight: "1.6",
                                      }}
                                    >
                                      {promptText}
                                    </p>
                                  </div>
                                );
                              })
                            ) : (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  height: "100%",
                                  minHeight: "250px",
                                  color: "#64748b",
                                  fontSize: "14px",
                                  fontStyle: "italic",
                                  textAlign: "center",
                                  gap: "8px",
                                }}
                              >
                                <i
                                  className="fa fa-info-circle"
                                  style={{ fontSize: "24px", color: "#94a3b8" }}
                                ></i>
                                No Record Found
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Notes Section */}
                    <div
                      className="transcription-white-global"
                      style={{ paddingBottom: "10px" }}
                    >
                      <div className="transcription-box ">
                        <div
                          className="transcription-header"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <h4 style={{ margin: 0 }}>Comments</h4>
                          <button
                            onClick={() => {
                              setNotesInput("");
                              setShowAddNoteModal(true);
                            }}
                            style={{
                              backgroundColor: "#5bc0de",
                              color: "white",
                              border: "none",
                              borderRadius: "6px",
                              padding: "5px 14px",
                              fontSize: "12px",
                              fontWeight: "600",
                              cursor: "pointer",
                              whiteSpace: "nowrap",
                            }}
                          >
                            + Add Comment
                          </button>
                        </div>

                        {/* Notes list */}
                        <div
                          style={{
                            maxHeight: "240px",
                            overflowY: "auto",
                            // padding: "10px 16px 10px",
                            marginTop: "20px",
                          }}
                        >
                          {(notesData?.notes?.length ?? 0) === 0 ? (
                            <p
                              style={{
                                color: "#9ca3af",
                                fontSize: "14px",
                                textAlign: "center",
                                padding: "24px 0",
                              }}
                            >
                              No comments added yet. Click &ldquo;+ Add
                              comment&rdquo; to get started.
                            </p>
                          ) : (
                            notesData?.notes?.map((note) => (
                              <div
                                key={note.id}
                                style={{
                                  display: "flex",
                                  alignItems: "flex-start",
                                  justifyContent: "space-between",
                                  padding: "8px 12px",
                                  marginBottom: "8px",
                                  background: "#eef2f5",
                                  borderRadius: "8px",
                                  border: "1px solid #d1d9e0",
                                }}
                              >
                                <div style={{ flex: 1 }}>
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "14px",
                                      color: "#2f3c4d",
                                      lineHeight: "1.5",
                                      wordBreak: "break-word",
                                    }}
                                  >
                                    {note.text}
                                  </p>
                                  <span
                                    style={{
                                      fontSize: "11px",
                                      color: "#9ca3af",
                                      marginTop: "4px",
                                      display: "block",
                                    }}
                                  >
                                    {note.date}
                                  </span>
                                </div>
                                <button
                                  onClick={() => setNoteToDelete(note.id)}
                                  title="Delete note"
                                  style={{
                                    background: "none",
                                    border: "none",
                                    cursor: "pointer",
                                    color: "#9ca3af",
                                    marginLeft: "10px",
                                    padding: "2px 4px",
                                    flexShrink: 0,
                                  }}
                                >
                                  <i
                                    className="fa fa-trash"
                                    aria-hidden="true"
                                    style={{ fontSize: "14px" }}
                                  />
                                </button>
                              </div>
                            ))
                          )}
                        </div>
                      </div>
                    </div>
                    {/* End Notes Section */}

                    {/* Add Note Modal */}
                    {showAddNoteModal && (
                      <div
                        style={{
                          position: "fixed",
                          inset: 0,
                          background: "rgba(0,0,0,0.45)",
                          zIndex: 9999,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => setShowAddNoteModal(false)}
                      >
                        <div
                          style={{
                            background: "#fff",
                            borderRadius: "10px",
                            padding: "28px 28px 22px",
                            width: "460px",
                            maxWidth: "92vw",
                            boxShadow: "0 8px 30px rgba(0,0,0,0.16)",
                            position: "relative",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            onClick={() => setShowAddNoteModal(false)}
                            style={{
                              position: "absolute",
                              top: "12px",
                              right: "16px",
                              background: "none",
                              border: "none",
                              fontSize: "20px",
                              cursor: "pointer",
                              color: "#6b7280",
                            }}
                          >
                            &times;
                          </button>
                          <h3
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              marginBottom: "14px",
                              color: "#1e293b",
                            }}
                          >
                            Add Comment
                          </h3>
                          <textarea
                            rows={4}
                            placeholder="Write your comment here..."
                            value={notesInput}
                            onChange={(e) => setNotesInput(e.target.value)}
                            style={{
                              width: "100%",
                              border: "1px solid #d1d9e0",
                              borderRadius: "8px",
                              padding: "10px 12px",
                              fontSize: "14px",
                              color: "#2f3c4d",
                              resize: "vertical",
                              outline: "none",
                              boxSizing: "border-box",
                            }}
                          />
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              gap: "10px",
                              marginTop: "14px",
                            }}
                          >
                            <button
                              onClick={() => setShowAddNoteModal(false)}
                              className="px-6 py-2 bg-gray-400 text-white rounded hover:bg-red-600"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={handleAddNote}
                              className="px-6 py-2 bg-blue-800 text-white rounded"
                            >
                              Save Comment
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Delete Note Confirmation Modal */}
                    {noteToDelete !== null && (
                      <div
                        style={{
                          position: "fixed",
                          inset: 0,
                          background: "rgba(0,0,0,0.45)",
                          zIndex: 9999,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        onClick={() => setNoteToDelete(null)}
                      >
                        <div
                          style={{
                            background: "#fff",
                            borderRadius: "10px",
                            padding: "28px",
                            width: "380px",
                            maxWidth: "90vw",
                            boxShadow: "0 8px 30px rgba(0,0,0,0.16)",
                            textAlign: "center",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <i
                            className="fa fa-trash"
                            style={{
                              fontSize: "32px",
                              color: "#ef4444",
                              marginBottom: "12px",
                              display: "block",
                            }}
                          />
                          <h3
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              color: "#1e293b",
                              marginBottom: "8px",
                            }}
                          >
                            Delete Note?
                          </h3>
                          <p
                            style={{
                              fontSize: "13px",
                              color: "#6b7280",
                              marginBottom: "20px",
                            }}
                          >
                            Are you sure you want to delete this note?
                          </p>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: "12px",
                            }}
                          >
                            <button
                              onClick={() => setNoteToDelete(null)}
                              className="px-6 py-2 bg-gray-400 text-white rounded hover:bg-gray-500"
                            >
                              Cancel
                            </button>
                            <button
                              onClick={confirmDeleteNote}
                              className="px-6 py-2 bg-red-600 text-white rounded"
                            >
                              Confirm
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>

                  <div>
                    {callInsight.call_type === "Collection" && (
                      <div
                        className="white-box-global"
                        // style={{ height: "100px" }}
                      >
                        <div className=" flex justify-between p-8">
                          <h1
                            className=" font-medium leading-6"
                            style={{ fontSize: "18px", color: "#4a5372" }}
                          >
                            Collection Status
                          </h1>
                          {/* <h1 className=" font-medium text-[18px] leading-6 text-[#4a5372]">
                               Recommendation
                             </h1> */}
                        </div>
                        <div className=" ">
                          <div className=" flex items-center">
                            <div className="p-4 mr-4  critical-per1 whitespace-nowrap mx-4">
                              Dataklout:{" "}
                              <label>
                                {callInsight?.collection_intent?.status ?? "-"}
                              </label>
                            </div>
                            <div
                              class="bg-neutral-200 w-full rounded-xl bg-gray-100"
                              style={{
                                height: "18px",
                                marginRight: "20px",
                                marginBottom: "6px",
                              }}
                            >
                              <div
                                class="bg-primary font-medium leading-none text-primary-100 rounded-xl flex justify-center items-center"
                                style={{
                                  width: `${callInsight?.collection_params?.progress_bar}%`,
                                  height: "18px",
                                }}
                              >
                                {callInsight?.collection_params?.progress_bar}%
                              </div>
                            </div>
                          </div>
                          <div className=" p-4 critical-per1 mx-4">
                            <span className=" flex" style={{ display: "flex" }}>
                              Reviewer :{" "}
                              <label>
                                {callInsight?.agent_collection_view}
                              </label>{" "}
                              <span className=" ml-4 cursor-pointer hover:text-red-600">
                                {" "}
                                <FiEdit
                                  onClick={() =>
                                    setShowCollectionReviewDetails(
                                      !showCollectionReviewDetails,
                                    )
                                  }
                                />
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    <div
                      className={`white-box-global keyword-white-box ${
                        clientName ? "mb-24" : ""
                      }`}
                    >
                      <div
                        className="white-box-header flex justify-between items-center"
                        style={{ padding: "0px" }}
                      >
                        <h3>Call Summary</h3>
                        <div className="tabs-container">
                          <div
                            className="tabs-header flex"
                            style={{
                              border: " 1px solid #e2e8f0",
                              borderRadius: "5px",
                            }}
                          >
                            <button
                              className={`tab-item px-6 py-2 ${
                                activeTab === "Dataklout"
                                  ? "bg-blue-900 text-white"
                                  : "text-gray-600"
                              }`}
                              onClick={() => setActiveTab("Dataklout")}
                            >
                              Dataklout
                            </button>
                            <button
                              className={`tab-item px-6 py-2 ${
                                activeTab === "Reviewer"
                                  ? "bg-blue-900 text-white"
                                  : "text-gray-600"
                              }`}
                              onClick={() => setActiveTab("Reviewer")}
                            >
                              Reviewer
                            </button>
                          </div>
                        </div>
                      </div>
                      <div
                        className="my-6 bg-[#eef2f5] overflow-y-scroll"
                        style={{ minHeight: "134px" }}
                      >
                        <div className="flex p-4" style={{ width: "100%" }}>
                          {activeTab === "Dataklout" ? (
                            <div style={{ width: "100%" }}>
                              {callInsight?.ai_summary?.summary ||
                                "No Summary found for this call"}
                            </div>
                          ) : (
                            <div style={{ width: "100%" }}>
                              <p
                                className="transcription-text"
                                contentEditable={isEditingReviewer}
                                suppressContentEditableWarning
                                ref={reviewerRef}
                                onFocus={(e) => {
                                  if (isEditingReviewer)
                                    placeCaretAtEndSummary(e.currentTarget);
                                }}
                                onBlur={handleReviewerBlur}
                                onClick={handleReviewerClick}
                                onKeyDown={handleReviewerKeyDown}
                                style={{
                                  cursor: isEditingReviewer ? "text" : "text",
                                  outline: isEditingReviewer ? "none" : "",
                                  boxShadow: isEditingReviewer ? "none" : "",
                                  WebkitTapHighlightColor: isEditingReviewer
                                    ? "transparent"
                                    : "",
                                  userSelect: isEditingReviewer
                                    ? "auto"
                                    : "text",
                                  minHeight: "80px",
                                  whiteSpace: "pre-wrap",
                                }}
                              >
                                {reviewerSummary ||
                                  "No Summary found for this call"}
                              </p>

                              {isEditingReviewer && (
                                <div
                                  className="flex justify-end mt-2"
                                  style={{ gap: "8px" }}
                                >
                                  <button
                                    className="px-6 py-2 bg-gray-400 text-white rounded hover:bg-red-600"
                                    style={{
                                      backgroundColor: "#grey",
                                    }}
                                    onClick={handleCancelEdit}
                                    disabled={isSaving}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    style={{
                                      // border: "1px solid #2563eb",

                                      color: "white",
                                    }}
                                    className="px-6 py-2 bg-blue-900 text-white rounded hover:bg-orange-500"
                                    onClick={async () => {
                                      const el = reviewerRef.current;
                                      const currentText =
                                        (el && el.innerText) || reviewerSummary;
                                      try {
                                        await saveReviewerSummary(currentText);
                                      } catch (err) {}
                                    }}
                                    disabled={isSaving}
                                  >
                                    {isSaving ? "Saving..." : "Save"}
                                  </button>
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                      </div>

                      <div
                        className=" flex justify-end mt-4"
                        style={{ fontSize: "12px" }}
                      >
                        * Powered by
                        <span className=" text-red-800 ml-2">
                          {" "}
                          Dataklout Gen Ai .
                        </span>
                      </div>
                    </div>
                  </div>
                  {/*  */}

                  {useCase === "Third Party Collection Agency" ? (
                    <div
                      className="white-box-global"
                      // style={{ height: "330px" }}
                    >
                      <div className="white-box-header">
                        <h3>Call Category</h3>
                      </div>
                      <div className="call-category-body">
                        <div className="call-category-form">
                          <div className="flex flex-wrap gap-2">
                            <div className="flex-1">
                              <div className="input-form">
                                <label>Product</label>
                                <input
                                  type="text"
                                  name=""
                                  placeholder=""
                                  value={category?.script_type}
                                />
                              </div>
                            </div>
                            <div className="flex-1">
                              <div
                                className="input-form"
                                style={{ border: "none" }}
                              >
                                <label>Available Offers</label>
                                <input
                                  type="text"
                                  value={"3 EMI waived off"}
                                  style={{
                                    zIndex: "1",

                                    width: "100%",
                                    height: "44px",
                                    background: "#e8ebef",
                                    borderRadius: "2px",
                                    fontWeight: "normal",
                                    fontSize: "16px",
                                    letterSpacing: "0.095em",
                                    color: "#2f3c4d",

                                    outline: "none",
                                    textAlign: "initial",
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {storage.getItem("critical_factor_module") === "true" ? (
                    <div className="white-box-global">
                      <div className="white-box-header">
                        <h3>Service Report</h3>
                      </div>
                      <div className="call-category-body">
                        <div className="call-category-form">
                          {criticalFactor && (
                            <div className="flex flex-wrap gap-2">
                              <div className="flex-1">
                                <div className="form-col clearfix">
                                  <label>Request Type</label>
                                  <input
                                    type="text"
                                    name=""
                                    placeholder="Request Type"
                                    value={callInsight.call_type}
                                  />
                                </div>
                              </div>
                              <div className="flex-1">
                                <div className="form-col clearfix">
                                  <label>Product</label>
                                  <select
                                    onChange={(e) =>
                                      criticalValueSelectionChnage(
                                        "product",
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option></option>
                                    {criticalFactor.product.map(
                                      (productItem) =>
                                        productItem.status ? (
                                          <option
                                            value={productItem.id}
                                            selected
                                          >
                                            {productItem.title}
                                          </option>
                                        ) : (
                                          <option value={productItem.id}>
                                            {productItem.title}
                                          </option>
                                        ),
                                    )}
                                  </select>
                                </div>
                              </div>
                              <div className="flex-1">
                                <div className="form-col clearfix">
                                  <label>Manufacturer</label>
                                  <select
                                    onChange={(e) =>
                                      criticalValueSelectionChnage(
                                        "manufacturer",
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option></option>
                                    {criticalFactor.manufacturer.map(
                                      (manufacturerItem) =>
                                        manufacturerItem.status ? (
                                          <option
                                            value={manufacturerItem.id}
                                            selected
                                          >
                                            {manufacturerItem.title}
                                          </option>
                                        ) : (
                                          <option value={manufacturerItem.id}>
                                            {manufacturerItem.title}
                                          </option>
                                        ),
                                    )}
                                  </select>
                                </div>
                              </div>
                              <div className="flex-1">
                                <div className="form-col clearfix">
                                  <label>Part No</label>
                                  <select
                                    onChange={(e) =>
                                      criticalValueSelectionChnage(
                                        "part_no",
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option></option>
                                    {criticalFactor.part_no.map((partNoItem) =>
                                      partNoItem.status ? (
                                        <option value={partNoItem.id} selected>
                                          {partNoItem.title}
                                        </option>
                                      ) : (
                                        <option value={partNoItem.id}>
                                          {partNoItem.title}
                                        </option>
                                      ),
                                    )}
                                  </select>
                                </div>
                              </div>
                              <div className="flex-1">
                                <div className="form-col clearfix">
                                  <label>Model</label>
                                  <select
                                    onChange={(e) =>
                                      criticalValueSelectionChnage(
                                        "model_no_list",
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option></option>
                                    {criticalFactor.model_no_list.map(
                                      (model_no_listItem) =>
                                        model_no_listItem.status ? (
                                          <option
                                            value={model_no_listItem.id}
                                            selected
                                          >
                                            {model_no_listItem.title}
                                          </option>
                                        ) : (
                                          <option value={model_no_listItem.id}>
                                            {model_no_listItem.title}
                                          </option>
                                        ),
                                    )}
                                  </select>
                                </div>
                              </div>
                              <div className="flex-1">
                                <div className="form-col clearfix">
                                  <label>Problem</label>
                                  <input
                                    type="text"
                                    value={problem}
                                    onChange={(e) => setProblem(e.target.value)}
                                  />
                                </div>
                              </div>
                              <div className="flex-1">
                                <div className="form-col clearfix">
                                  <label>Resolution</label>
                                  <input
                                    type="text"
                                    value={resolution}
                                    onChange={(e) =>
                                      setResolution(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="flex-1">
                                <div className="review-button">
                                  <input
                                    type="submit"
                                    name=""
                                    value="Update"
                                    onClick={updateCriticalFactor}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {storage.getItem("client") === "DBS Bank Singapore" ? (
                        <div
                          className="white-box-global"
                          // style={{
                          //   height:
                          //     callInsight.product == "Equity"
                          //       ? "620px"
                          //       : "560px",
                          // }}
                        >
                          <div className="white-box-header">
                            <h3>Category</h3>
                          </div>
                          {showedit ? (
                            <div className="call-category-body">
                              <div className="call-category-form">
                                <div
                                  className="flex flex-wrap gap-4 flex-row"
                                  id="target-lable"
                                >
                                  <div className="">
                                    <div className="input-form">
                                      <label>Request Type</label>
                                      <input
                                        type="text"
                                        name=""
                                        placeholder="Request Type"
                                        value={callInsight.call_type}
                                      />
                                    </div>
                                  </div>
                                  <div className="">
                                    <div className="input-form">
                                      <label>Product</label>
                                      <input
                                        type="text"
                                        name=""
                                        placeholder=""
                                        value={callInsight.product}
                                        // onChange={() => console.log("hyhyh")}
                                      />
                                    </div>
                                  </div>
                                  <div className="">
                                    <div className="input-form">
                                      <label>Name</label>
                                      <input
                                        type="text"
                                        name=""
                                        value={callInsight.name}
                                      />
                                    </div>
                                  </div>
                                  <div className="">
                                    <div className="input-form">
                                      <label>Buy</label>
                                      <input
                                        type="text"
                                        name=""
                                        value={callInsight.buy}
                                      />
                                    </div>
                                  </div>
                                  <div className="">
                                    <div className="input-form">
                                      <label>Sell</label>
                                      <input
                                        type="Amount"
                                        name=""
                                        value={callInsight.sell}
                                      />
                                    </div>
                                  </div>
                                  <div className="">
                                    <div className="input-form">
                                      <label>
                                        {callInsight?.product == "Equity"
                                          ? "Price"
                                          : callInsight?.product == "Forex"
                                            ? "Final Price"
                                            : "Date"}
                                      </label>
                                      <input
                                        type="text"
                                        name=""
                                        value={
                                          callInsight?.product == "Equity"
                                            ? callInsight.price
                                            : callInsight?.product == "Forex"
                                              ? callInsight.final_price
                                              : callInsight.date
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="">
                                    <div className="input-form">
                                      <label>
                                        {callInsight?.product == "Equity"
                                          ? "Shares"
                                          : callInsight?.product == "Forex"
                                            ? "Quantity"
                                            : "Units"}
                                      </label>
                                      <input
                                        type="text"
                                        name=""
                                        value={
                                          callInsight?.product == "Equity"
                                            ? callInsight.shares
                                            : callInsight?.product == "Forex"
                                              ? callInsight.quantity
                                              : callInsight.units
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div className="">
                                    <div className="input-form">
                                      <label> Amount</label>
                                      <input
                                        type="text"
                                        name=""
                                        value={callInsight.amount}
                                      />
                                    </div>
                                  </div>
                                  <div className="">
                                    <div className="input-form">
                                      <label>
                                        {callInsight?.product == "Equity"
                                          ? "Profile Id"
                                          : callInsight?.product == "Forex"
                                            ? "Contract Number"
                                            : "Folio Number"}
                                      </label>
                                      <input
                                        type="text"
                                        name=""
                                        value={
                                          callInsight?.product == "Equity"
                                            ? callInsight.profile_id
                                            : callInsight?.product == "Forex"
                                              ? callInsight.contract_number
                                              : callInsight.folio_number
                                        }
                                      />
                                    </div>
                                  </div>
                                  {callInsight.product !== "Forex" && (
                                    <div className="flex-1">
                                      <div className="input-form">
                                        <label>Company</label>
                                        <input
                                          type="text"
                                          name=""
                                          value={callInsight.company_name}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div>
                                  <div className="">
                                    <div className="">
                                      <input
                                        type="submit"
                                        name=""
                                        value="Edit"
                                        onClick={() => setshowedit(false)}
                                        style={{
                                          background: "orange",
                                          color: "white",
                                        }}
                                        className="px-8 py-3 rounded-lg"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ) : (
                            <div

                            // style={customStyles}
                            >
                              <form onSubmit={handleSubmit}>
                                <div className="editpanel">
                                  <div className="bg-gray ">
                                    <div className="w-full">
                                      <div className="call-category-body">
                                        <div className="call-category-form">
                                          <div
                                            className="flex flex-wrap gap-4 flex-row"
                                            id="target-lable"
                                          >
                                            <div className="">
                                              <div className="input-form">
                                                <label>Request Type</label>
                                                <input
                                                  type="text"
                                                  name="request_type"
                                                  value={
                                                    updatedCallInsight.request_type
                                                  }
                                                  onChange={handleInputChange}
                                                />
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="input-form">
                                                <label>Product</label>
                                                <input
                                                  type="text"
                                                  name="product"
                                                  placeholder=""
                                                  value={
                                                    updatedCallInsight.product
                                                  }
                                                  onChange={handleInputChange}
                                                />
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="input-form">
                                                <label>Name</label>
                                                <input
                                                  type="text"
                                                  name="name"
                                                  value={
                                                    updatedCallInsight.name
                                                  }
                                                  onChange={handleInputChange}
                                                />
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="input-form">
                                                <label>Buy</label>
                                                <input
                                                  type="text"
                                                  name="buy"
                                                  value={updatedCallInsight.buy}
                                                  onChange={handleInputChange}
                                                />
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="input-form">
                                                <label>Sell</label>
                                                <input
                                                  type="Amount"
                                                  name="sell"
                                                  value={
                                                    updatedCallInsight.sell
                                                  }
                                                  onChange={handleInputChange}
                                                />
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="input-form">
                                                <label>
                                                  {callInsight?.product ==
                                                  "Equity"
                                                    ? "Price"
                                                    : callInsight?.product ==
                                                        "Forex"
                                                      ? "Final Price"
                                                      : "Date"}
                                                </label>
                                                <input
                                                  type="text"
                                                  name={
                                                    callInsight.product ===
                                                    "Forex"
                                                      ? "final_price"
                                                      : callInsight.product ===
                                                          "Equity"
                                                        ? "price"
                                                        : "date"
                                                  }
                                                  onChange={handleInputChange}
                                                  value={
                                                    callInsight.product ===
                                                    "Forex"
                                                      ? updatedCallInsight.final_price
                                                      : callInsight.product ===
                                                          "Equity"
                                                        ? updatedCallInsight.price
                                                        : updatedCallInsight.date
                                                  }
                                                />
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="input-form">
                                                <label>
                                                  {callInsight?.product ==
                                                  "Equity"
                                                    ? "Shares"
                                                    : callInsight?.product ==
                                                        "Forex"
                                                      ? "Quantity"
                                                      : "Units"}
                                                </label>
                                                <input
                                                  type="text"
                                                  name={
                                                    callInsight?.product ==
                                                    "Equity"
                                                      ? "shares"
                                                      : callInsight?.product ==
                                                          "Forex"
                                                        ? "quantity"
                                                        : "units"
                                                  }
                                                  onChange={handleInputChange}
                                                  value={
                                                    callInsight?.product ==
                                                    "Forex"
                                                      ? updatedCallInsight.quantity
                                                      : callInsight?.product ==
                                                          "Equity"
                                                        ? updatedCallInsight.shares
                                                        : updatedCallInsight.units
                                                  }
                                                />
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="input-form">
                                                <label> Amount</label>
                                                <input
                                                  type="text"
                                                  name="amount"
                                                  onChange={handleInputChange}
                                                  value={
                                                    updatedCallInsight.amount
                                                  }
                                                />
                                              </div>
                                            </div>
                                            <div className="">
                                              <div className="input-form">
                                                <label>
                                                  {callInsight?.product ==
                                                  "Equity"
                                                    ? "Profile Id"
                                                    : callInsight?.product ==
                                                        "Forex"
                                                      ? "Contract Number"
                                                      : "Folio Number"}
                                                </label>
                                                <input
                                                  type="text"
                                                  name={
                                                    callInsight?.product ==
                                                    "Equity"
                                                      ? "profile_id"
                                                      : callInsight?.product ==
                                                          "Forex"
                                                        ? "contract_number"
                                                        : "folio_number"
                                                  }
                                                  onChange={handleInputChange}
                                                  value={
                                                    callInsight?.product ==
                                                    "Forex"
                                                      ? updatedCallInsight.contract_number
                                                      : callInsight?.product ==
                                                          "Equity"
                                                        ? updatedCallInsight.profile_id
                                                        : updatedCallInsight.folio_number
                                                  }
                                                />
                                              </div>
                                            </div>
                                            {callInsight.product !==
                                              "Forex" && (
                                              <div className="">
                                                <div className="input-form">
                                                  <label>Company</label>
                                                  <input
                                                    type="text"
                                                    name="company_name"
                                                    onChange={handleInputChange}
                                                    value={
                                                      updatedCallInsight.company_name
                                                    }
                                                  />
                                                </div>
                                              </div>
                                            )}

                                            {/* <div className="mt-50 "></div> */}
                                          </div>
                                        </div>
                                      </div>

                                      <button
                                        type="submit"
                                        className="text-white bg-blue-500  rounded-lg mb-8 "
                                        style={{
                                          padding: "13px 30px 13px 30px",
                                          marginLeft: "27px",
                                        }}
                                      >
                                        Save
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          )}
                        </div>
                      ) : useCase == "Insurance - PCVC Verification" ? (
                        <div
                          className="white-box-global"
                          // style={{ height: "330px" }}
                        >
                          <div className="white-box-header">
                            <h3>Call Category</h3>
                          </div>
                          <div className="call-category-body">
                            <div className="call-category-form">
                              <div className="flex flex-wrap gap-2">
                                <div className="flex-1">
                                  <div className="input-form">
                                    <label>Script Type</label>
                                    <input
                                      type="text"
                                      name=""
                                      placeholder=""
                                      value={category?.script_type}
                                    />
                                  </div>
                                </div>
                                <div className="flex-1">
                                  <div
                                    className="input-form"
                                    style={{ border: "none" }}
                                  >
                                    <label>Product</label>
                                    <input
                                      type="text"
                                      value={category?.product}
                                      style={{
                                        zIndex: "1",

                                        width: "100%",
                                        height: "44px",
                                        background: "#e8ebef",
                                        borderRadius: "2px",
                                        fontWeight: "normal",
                                        fontSize: "16px",
                                        letterSpacing: "0.095em",
                                        color: "#2f3c4d",

                                        outline: "none",
                                        textAlign: "initial",
                                      }}
                                    />
                                    {/* <Dropdown
                                        noCaret
                                        style={{
                                          zIndex: "1",

                                          width: "100%",
                                          height: "44px",
                                          background: "#e8ebef",
                                          borderRadius: "2px",
                                          fontWeight: "normal",
                                          fontSize: "16px",
                                          letterSpacing: "0.095em",
                                          color: "#2f3c4d",

                                          outline: "none",
                                          textAlign: "initial",
                                        }}
                                        id="callInsight-dropown"
                                        size="lg"
                                        placement="topRight"
                                        activeKey={activeKey}
                                        onSelect={(eventKey) =>
                                          setActiveKey(eventKey)
                                        }
                                      >
                                        {Items.map((e) => (
                                          <Dropdown.Menu
                                            title={e.title}
                                            eventKey={e.title}
                                          >
                                            {e.submenu.map((e) => (
                                              <Dropdown.Item
                                                eventKey={e.title}
                                                key={e.title}
                                              >
                                                {e.title}
                                              </Dropdown.Item>
                                            ))}
                                          </Dropdown.Menu>
                                        ))}
                                      </Dropdown> */}
                                  </div>
                                </div>
                                <div className="flex-1">
                                  <div className="input-form">
                                    <label>Customer</label>
                                    <input
                                      type="text"
                                      name=""
                                      placeholder=""
                                      value={category?.customer}
                                    />
                                  </div>
                                </div>
                                {/* <div className="col-md-6">
                                    <div
                                      className="review-button"
                                      style={{ marginTop: "30px" }}
                                    >
                                      <input
                                        type="submit"
                                        name=""
                                        value="Save"
                                      />
                                    </div>
                                  </div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : clientName == "Hindustan Unilever" ? (
                        <div
                          className="uniliver-notes"
                          style={{ backgroundColor: "white" }}
                        >
                          <div
                            className=""
                            id="target-lable"
                            style={{
                              width: "70%",
                              borderRight: "1px",
                            }}
                          >
                            <div
                              className="white-box-header"
                              style={{ marginLeft: "5pxpx" }}
                            >
                              <h3>Call Category</h3>
                            </div>

                            <div className="">
                              <div
                                className="input-form"
                                style={{ marginLeft: "5px", width: "80%" }}
                              >
                                <label>Request Type</label>
                                <input
                                  type="text"
                                  name=""
                                  placeholder="Service Request"
                                />
                              </div>
                            </div>
                            <div className="">
                              <div
                                className="input-form"
                                style={{ marginLeft: "5px", width: "80%" }}
                              >
                                <label> Product</label>
                                <input
                                  type="text"
                                  name=""
                                  placeholder="Clinic Plus Shampoo"
                                />
                              </div>
                            </div>
                            <div className="">
                              <div
                                className="input-form"
                                style={{ marginLeft: "5px", width: "80%" }}
                              >
                                <label>Category</label>
                                <input
                                  type="text"
                                  name=""
                                  placeholder="Shampoo & Conditioner"
                                />
                              </div>
                            </div>
                            <div className=" edit ">
                              <div
                                className="review-button-edit"
                                style={{ marginTop: "18px" }}
                              >
                                <button
                                  className="btn Save"
                                  style={{
                                    background: "#270086",
                                    color: "white",
                                    padding: "5px 20px",
                                    fontWeight: " 500",
                                    fontSize: "14px",
                                    outline: "none",

                                    lineHeight: "118%",
                                    textAlign: "center",
                                    letterSpacing: "0.045em",
                                    color: " #e3e3e3",
                                    outline: "none",
                                    border: "none",
                                    padding: "9px 44px",
                                    transition: "all 0.4s ease-in-out",
                                  }}
                                >
                                  save
                                </button>
                              </div>
                            </div>
                          </div>
                          <div
                            className="vr"
                            style={{
                              margin: "5px 15px",
                              height: "auto",
                              border: "1px solid #eae5e5",
                            }}
                          ></div>

                          <div
                            className="form-col clearfix"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            <div className="white-box-header">
                              <h3>Notes</h3>
                            </div>

                            <div
                              className=""
                              style={{
                                width: "auto",
                                marginTop: " -3px",
                                marginBottom: "19px",
                              }}
                            >
                              <label
                                className="notes-lable"
                                style={{
                                  fontWeight: "normal",
                                  fontSize: "16px",
                                  letterSpacing: " 0.095em",
                                  color: "#737d8b",
                                  marginBottom: "5px",
                                }}
                              >
                                Subject
                              </label>

                              <select>
                                <option>Clinic Plus Shampoo</option>
                                <option>Glow & Lovely</option>
                                <option>Kissan Ketchup</option>
                                <option>Skin Care</option>
                                <option>Hair Care</option>
                              </select>
                            </div>
                            <div className="" style={{ width: "auto" }}>
                              <label
                                style={{
                                  fontWeight: "normal",
                                  fontSize: "16px",
                                  letterSpacing: " 0.095em",
                                  color: "#737d8b",
                                  marginBottom: "5px",
                                }}
                              >
                                Add Notes
                              </label>
                              <textarea
                                rows={4}
                                cols={50}
                                style={{ height: "140px" }}
                              />
                            </div>
                            {/* <div className="col-md-1">
                                        <input type="color" />
                                      </div> */}
                            <div className="">
                              <div style={{ marginTop: "27px" }}>
                                <button
                                  className="btn Save"
                                  style={{
                                    background: "#270086",
                                    color: "white",
                                    padding: "5px 20px",
                                    fontWeight: " 500",
                                    fontSize: "14px",
                                    outline: "none",
                                    marginTop: "13px",
                                    lineHeight: "118%",
                                    textAlign: "center",
                                    letterSpacing: "0.045em",
                                    color: " #e3e3e3",
                                    outline: "none",
                                    border: "none",
                                    padding: "9px 44px",
                                    transition: "all 0.4s ease-in-out",
                                  }}
                                >
                                  submit
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </Masonry>
              </div>
            )}
          </div>
          {/* {localStorage.getItem("usecase") !==
          "Third Party Collection Agency" ? (
            <div className="row">
              <div className="col-lg-6 mb-20">
                <div className="white-box-global keyword-white-box">
                  <div className="white-box-header">
                    <h3>Call Summary</h3>
                  </div>
                  <div className="p-5 h-[249px]  bg-[#eef2f5] overflow-y-scroll">
                    {callInsight?.keywords.map((keyword) => (
                      <div>
                        Lorem ipsum, dolor sit amet consectetur adipisicing
                        elit. Nesciunt, et." Lorem ipsum dolor sit amet,
                        consectetur adipisicing elit. Quidem, facere?
                      </div>
                    ))}
                  </div>
                  <div className=" flex justify-end text-[12px] mt-4">
                    * Powered by
                    <span className=" text-red-800 ml-2">
                      {" "}
                      Dataklout Gen Ai
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            ""
          )} */}
        </div>
      </section>
      <Footer />

      <Modal isOpen={showCollectionReviewDetails} style={customStyles}>
        <div className="modal-dialog" role="document">
          <div className="my-calls-popup-details">
            <h2>
              <div className="icon-div">
                <div>
                  <i
                    style={{ color: "white" }}
                    className="fa fa-user"
                    aria-hidden="true"
                  ></i>
                </div>
              </div>
              Collection Status
            </h2>
            <div className="my-calls-form">
              <div className="row">
                <div className="col-md-12">
                  {callInsight &&
                    callInsight.agent_id === storage.getItem("username") && (
                      <>
                        {collectionStatusData &&
                          collectionStatusData.accepted === null && (
                            <p>Manager's Action : Pending</p>
                          )}
                        {collectionStatusData &&
                          collectionStatusData.accepted !== null && (
                            <>
                              <div className="form-col clearfix">
                                <label>Manager's Action : </label>
                                {collectionStatusData.accepted === true && (
                                  <BsCheckLg color="green" />
                                )}
                                {collectionStatusData.accepted === false && (
                                  <FaTimes color="red" />
                                )}
                              </div>

                              <div className="form-col clearfix">
                                <label>Comment </label>
                                <br />
                                <p>
                                  <b>{collectionStatusData.comment}</b>
                                </p>
                              </div>
                            </>
                          )}
                        <div className="form-col clearfix">
                          <label>Collection Status </label>
                          <br />
                          <select
                            onChange={(e) =>
                              setCollectionStatus(e.target.value)
                            }
                          >
                            <option value={collectionStatus}>
                              {collectionStatus}
                            </option>
                            <option value="Promise Broken">
                              Promise Broken
                            </option>
                            <option value="Denial">Denial</option>
                            <option value="Settlement">Settlement</option>
                          </select>
                        </div>
                      </>
                    )}

                  {callInsight &&
                    callInsight.agent_id !== storage.getItem("username") && (
                      <>
                        <div className="form-col clearfix">
                          <label>Current Status </label>
                          <br />
                          <p>
                            <b>
                              {collectionStatusData &&
                                collectionStatusData.updated_status}
                            </b>
                          </p>
                        </div>

                        {collectionStatusData && (
                          <>
                            <div className="form-col clearfix">
                              <label>Accept </label>
                              <div className="toggle-switch">
                                <div className="toggle-switch-intregrate">
                                  <input
                                    type="checkbox"
                                    id="switch"
                                    onChange={() => setAccepted(!accepted)}
                                  />{" "}
                                  <label htmlFor="switch"></label>
                                </div>
                              </div>
                            </div>

                            <div className="form-col clearfix">
                              <label>Comment </label>
                              <br />
                              <input
                                type="text"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                              />
                            </div>
                          </>
                        )}
                      </>
                    )}
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <p className="errorColor"></p>
                </div>
              </div>
            </div>
            <div className="border"></div>
            <div className="popup-footer">
              <>
                <button
                  className="btn"
                  type="button"
                  onClick={() =>
                    setShowCollectionReviewDetails(!showCollectionReviewDetails)
                  }
                >
                  {" "}
                  Cancel{" "}
                </button>
                <button
                  className="btn Save"
                  type="button"
                  onClick={() => updateCollectionStatusData()}
                >
                  {" "}
                  Update{" "}
                </button>
              </>
            </div>
          </div>
        </div>
      </Modal>

      <Modal isOpen={showArchiveModel} style={customStyles}>
        <div className="modal-dialog" role="document">
          <div className="my-calls-popup-details">
            <h2>Do you want to Archive this call ?</h2>

            <div className="popup-footer">
              <>
                <button
                  className="btn"
                  type="button"
                  onClick={() => setShowArchiveModel(false)}
                >
                  {" "}
                  Cancel{" "}
                </button>
                <button
                  className="btn Save"
                  type="button"
                  onClick={() => markArchive()}
                >
                  {" "}
                  Confirm{" "}
                </button>
              </>
            </div>
          </div>
        </div>
      </Modal>

      {showOpportunitySRModel && (
        <div className="modal my-calls-popup show" style={{ margin: "50px" }}>
          <div className="backdrop"></div>
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "50px" }}
          >
            <div className="my-calls-popup-details">
              <h2>
                <div className="icon-div">
                  <div>
                    <span>
                      <img
                        src="assets/images/user-icon.png"
                        className="img-responsive"
                        alt=""
                      />
                    </span>
                  </div>
                </div>
                Create New {clickType}
              </h2>

              <div className="my-calls-form">
                <div className="row">
                  <div className="col-md-3"></div>
                  <div className="col-md-6">
                    <div className="form-col clearfix">
                      <label>Product </label>
                      <br />
                      <select onChange={(e) => setProductID(e.target.value)}>
                        <option value=""></option>
                        {supportingInfo.product.map((product) => (
                          <option value={product.id}>{product.title}</option>
                        ))}
                      </select>
                    </div>

                    <div className="form-col clearfix">
                      <label>Keyword </label>
                      <br />
                      <input
                        type="text"
                        value={keyword}
                        onChange={(e) => setkeyword(e.target.value)}
                      />
                    </div>

                    <div className="form-col clearfix">
                      <label>Status </label>
                      <br />
                      <select onChange={(e) => setStatus(e.target.value)}>
                        <option value=""></option>
                        <option value="New">New</option>
                      </select>
                    </div>
                  </div>
                </div>

                {/* {supportingInfoPending &&
                                        (<div className="empty-call">
                                            Loadg...
                                        </div>)}

                                    <div className="row">
                                        <div className="col-md-12">
                                            <p className="errorColor">{supportingInfoError}</p>
                                            {
                                                uploadError &&
                                                <p className="errorColor">{uploadError}</p>
                                            }
                                        </div>
                                    </div> */}
              </div>

              <div className="border"></div>
              <div className="popup-footer">
                <>
                  <button
                    className="btn"
                    type="button"
                    onClick={() => setShowOpportunitySRModel(false)}
                  >
                    {" "}
                    Cancel{" "}
                  </button>
                  <button
                    className="btn Save"
                    type="button"
                    onClick={() => CreateOpportunitySR()}
                  >
                    {" "}
                    Create{" "}
                  </button>
                </>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CallInsight;
